/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';
import { Route as HealthzRouteImport } from './routes/healthz';
import { Route as DashboardRouteImport } from './routes/dashboard';
import { Route as LocaleRouteImport } from './routes/$locale';
import { Route as IndexRouteImport } from './routes/index';
import { Route as LocaleIndexRouteImport } from './routes/$locale/index';
import { Route as CertificatesCertificateLogIdRouteImport } from './routes/certificates.$certificateLogId';
import { Route as LocaleHelpdeskRouteImport } from './routes/$locale_.helpdesk';
import { Route as LocaleUnauthorizedRouteImport } from './routes/$locale/unauthorized';
import { Route as LocaleStudentRouteImport } from './routes/$locale/student';
import { Route as LocaleSignupRouteImport } from './routes/$locale/signup';
import { Route as LocaleRequestLoginLinkRouteImport } from './routes/$locale/request-login-link';
import { Route as LocaleRegisterRouteImport } from './routes/$locale/register';
import { Route as LocaleLoginRouteImport } from './routes/$locale/login';
import { Route as LocaleInstructorGrowthOperatingSystemRouteImport } from './routes/$locale/instructor-growth-operating-system';
import { Route as LocaleForgotPasswordRouteImport } from './routes/$locale/forgot-password';
import { Route as LocaleCliAuthRouteImport } from './routes/$locale/cli-auth';
import { Route as LocaleAuthenticatedRouteImport } from './routes/$locale/_authenticated';
import { Route as LocaleUiLibraryIndexRouteImport } from './routes/$locale/ui-library/index';
import { Route as LocaleCoursesIndexRouteImport } from './routes/$locale/courses/index';
import { Route as LocaleHelpdeskConnectRouteImport } from './routes/$locale_.helpdesk_.connect';
import { Route as LocaleCoursesCourseIdRouteImport } from './routes/$locale/courses/$courseId';
import { Route as LocaleAuthenticatedTranslationsRouteImport } from './routes/$locale/_authenticated/translations';
import { Route as LocaleAuthenticatedTeamDashboardRouteImport } from './routes/$locale/_authenticated/team-dashboard';
import { Route as LocaleAuthenticatedPaymentsRouteImport } from './routes/$locale/_authenticated/payments';
import { Route as LocaleAuthenticatedDashboardRouteImport } from './routes/$locale/_authenticated/dashboard';
import { Route as LocaleAuthenticatedAnalyticsGearRouteImport } from './routes/$locale/_authenticated/analytics-gear';
import { Route as LocaleAuthenticatedAccountRouteImport } from './routes/$locale/_authenticated/account';
import { Route as LocaleAuthenticatedWarehouseRouteRouteImport } from './routes/$locale/_authenticated/warehouse/route';
import { Route as LocaleAuthenticatedSyncRouteRouteImport } from './routes/$locale/_authenticated/sync/route';
import { Route as LocaleAuthenticatedStudentRouteRouteImport } from './routes/$locale/_authenticated/student/route';
import { Route as LocaleAuthenticatedShopifyRouteRouteImport } from './routes/$locale/_authenticated/shopify/route';
import { Route as LocaleAuthenticatedInstructorRouteRouteImport } from './routes/$locale/_authenticated/instructor/route';
import { Route as LocaleAuthenticatedGearErpRouteRouteImport } from './routes/$locale/_authenticated/gear-erp/route';
import { Route as LocaleAuthenticatedErpSyncRouteRouteImport } from './routes/$locale/_authenticated/erp-sync/route';
import { Route as LocaleAuthenticatedAnalyticsMoveRouteRouteImport } from './routes/$locale/_authenticated/analytics-move/route';
import { Route as LocaleAuthenticatedAnalyticsRouteRouteImport } from './routes/$locale/_authenticated/analytics/route';
import { Route as LocaleAuthenticatedAdminRouteRouteImport } from './routes/$locale/_authenticated/admin/route';
import { Route as LocaleAuthenticatedWarehouseIndexRouteImport } from './routes/$locale/_authenticated/warehouse/index';
import { Route as LocaleAuthenticatedSyncIndexRouteImport } from './routes/$locale/_authenticated/sync/index';
import { Route as LocaleAuthenticatedStudentIndexRouteImport } from './routes/$locale/_authenticated/student/index';
import { Route as LocaleAuthenticatedShopifyIndexRouteImport } from './routes/$locale/_authenticated/shopify/index';
import { Route as LocaleAuthenticatedInstructorIndexRouteImport } from './routes/$locale/_authenticated/instructor/index';
import { Route as LocaleAuthenticatedGearErpIndexRouteImport } from './routes/$locale/_authenticated/gear-erp/index';
import { Route as LocaleAuthenticatedErpSyncIndexRouteImport } from './routes/$locale/_authenticated/erp-sync/index';
import { Route as LocaleAuthenticatedCrmIndexRouteImport } from './routes/$locale/_authenticated/crm/index';
import { Route as LocaleAuthenticatedAnalyticsIndexRouteImport } from './routes/$locale/_authenticated/analytics/index';
import { Route as LocaleAuthenticatedAnalyticsMoveIndexRouteImport } from './routes/$locale/_authenticated/analytics-move/index';
import { Route as LocaleAuthenticatedAdminIndexRouteImport } from './routes/$locale/_authenticated/admin/index';
import { Route as LocaleRecoveryPasswordResetRecoveryRequestIdRouteImport } from './routes/$locale/recovery/password-reset/$recoveryRequestId';
import { Route as LocaleRecoveryLoginLinkRecoveryRequestIdRouteImport } from './routes/$locale/recovery/login-link/$recoveryRequestId';
import { Route as LocaleAuthenticatedWarehouseWarehousesRouteImport } from './routes/$locale/_authenticated/warehouse/warehouses';
import { Route as LocaleAuthenticatedWarehouseInventoryRouteImport } from './routes/$locale/_authenticated/warehouse/inventory';
import { Route as LocaleAuthenticatedSyncSweepRunsRouteImport } from './routes/$locale/_authenticated/sync/sweep-runs';
import { Route as LocaleAuthenticatedSyncRelationQueueRouteImport } from './routes/$locale/_authenticated/sync/relation-queue';
import { Route as LocaleAuthenticatedSyncOptionSetsRouteImport } from './routes/$locale/_authenticated/sync/option-sets';
import { Route as LocaleAuthenticatedSyncJobsRouteImport } from './routes/$locale/_authenticated/sync/jobs';
import { Route as LocaleAuthenticatedSyncDataTypesRouteImport } from './routes/$locale/_authenticated/sync/data-types';
import { Route as LocaleAuthenticatedStudentProgressRouteImport } from './routes/$locale/_authenticated/student/progress';
import { Route as LocaleAuthenticatedStudentPersonalFlowRouteImport } from './routes/$locale/_authenticated/student/personal-flow';
import { Route as LocaleAuthenticatedStudentMy_coursesRouteImport } from './routes/$locale/_authenticated/student/my_courses';
import { Route as LocaleAuthenticatedShopifyStockControlRouteImport } from './routes/$locale/_authenticated/shopify/stock-control';
import { Route as LocaleAuthenticatedPaymentsPaymentIdRouteImport } from './routes/$locale/_authenticated/payments/$paymentId';
import { Route as LocaleAuthenticatedInstructorStudentsRouteImport } from './routes/$locale/_authenticated/instructor/students';
import { Route as LocaleAuthenticatedInstructorDashboardRouteImport } from './routes/$locale/_authenticated/instructor/dashboard';
import { Route as LocaleAuthenticatedGearErpValidationRouteImport } from './routes/$locale/_authenticated/gear-erp/validation';
import { Route as LocaleAuthenticatedGearErpRegistryRouteImport } from './routes/$locale/_authenticated/gear-erp/registry';
import { Route as LocaleAuthenticatedGearErpReadinessRouteImport } from './routes/$locale/_authenticated/gear-erp/readiness';
import { Route as LocaleAuthenticatedGearErpProductsRouteImport } from './routes/$locale/_authenticated/gear-erp/products';
import { Route as LocaleAuthenticatedGearErpMigrationBatchesRouteImport } from './routes/$locale/_authenticated/gear-erp/migration-batches';
import { Route as LocaleAuthenticatedGearErpMappingRouteImport } from './routes/$locale/_authenticated/gear-erp/mapping';
import { Route as LocaleAuthenticatedGearErpFailuresRouteImport } from './routes/$locale/_authenticated/gear-erp/failures';
import { Route as LocaleAuthenticatedGearErpEvidenceRouteImport } from './routes/$locale/_authenticated/gear-erp/evidence';
import { Route as LocaleAuthenticatedGearErpDataQualityRouteImport } from './routes/$locale/_authenticated/gear-erp/data-quality';
import { Route as LocaleAuthenticatedErpSyncValidationRouteImport } from './routes/$locale/_authenticated/erp-sync/validation';
import { Route as LocaleAuthenticatedErpSyncRegistryRouteImport } from './routes/$locale/_authenticated/erp-sync/registry';
import { Route as LocaleAuthenticatedErpSyncReadinessRouteImport } from './routes/$locale/_authenticated/erp-sync/readiness';
import { Route as LocaleAuthenticatedErpSyncMigrationBatchesRouteImport } from './routes/$locale/_authenticated/erp-sync/migration-batches';
import { Route as LocaleAuthenticatedErpSyncMappingRouteImport } from './routes/$locale/_authenticated/erp-sync/mapping';
import { Route as LocaleAuthenticatedErpSyncFailuresRouteImport } from './routes/$locale/_authenticated/erp-sync/failures';
import { Route as LocaleAuthenticatedErpSyncEvidenceRouteImport } from './routes/$locale/_authenticated/erp-sync/evidence';
import { Route as LocaleAuthenticatedErpSyncDataQualityRouteImport } from './routes/$locale/_authenticated/erp-sync/data-quality';
import { Route as LocaleAuthenticatedCrmSearchRouteImport } from './routes/$locale/_authenticated/crm/search';
import { Route as LocaleAuthenticatedCrmAnalyticsRouteImport } from './routes/$locale/_authenticated/crm/analytics';
import { Route as LocaleAuthenticatedAnalyticsOverviewRouteImport } from './routes/$locale/_authenticated/analytics/overview';
import { Route as LocaleAuthenticatedAnalyticsGearExpressRouteImport } from './routes/$locale/_authenticated/analytics/gear-express';
import { Route as LocaleAuthenticatedAnalyticsMoveTranslationsRouteImport } from './routes/$locale/_authenticated/analytics-move/translations';
import { Route as LocaleAuthenticatedAnalyticsMoveTrainingProgramsRouteImport } from './routes/$locale/_authenticated/analytics-move/training-programs';
import { Route as LocaleAuthenticatedAnalyticsMoveRevenueRouteImport } from './routes/$locale/_authenticated/analytics-move/revenue';
import { Route as LocaleAuthenticatedAnalyticsMoveRegistrationsRouteImport } from './routes/$locale/_authenticated/analytics-move/registrations';
import { Route as LocaleAuthenticatedAnalyticsMoveRegistrationTop30RouteImport } from './routes/$locale/_authenticated/analytics-move/registration-top30';
import { Route as LocaleAuthenticatedAnalyticsMoveOverviewRouteImport } from './routes/$locale/_authenticated/analytics-move/overview';
import { Route as LocaleAuthenticatedAnalyticsMoveMembershipRouteImport } from './routes/$locale/_authenticated/analytics-move/membership';
import { Route as LocaleAuthenticatedAnalyticsMoveMembersRouteImport } from './routes/$locale/_authenticated/analytics-move/members';
import { Route as LocaleAuthenticatedAnalyticsMoveMapsRouteImport } from './routes/$locale/_authenticated/analytics-move/maps';
import { Route as LocaleAuthenticatedAnalyticsMoveMainLocationRouteImport } from './routes/$locale/_authenticated/analytics-move/main-location';
import { Route as LocaleAuthenticatedAnalyticsMoveEducationRouteImport } from './routes/$locale/_authenticated/analytics-move/education';
import { Route as LocaleAuthenticatedAnalyticsMoveCoursesRouteImport } from './routes/$locale/_authenticated/analytics-move/courses';
import { Route as LocaleAuthenticatedAnalyticsMoveCertificationsRouteImport } from './routes/$locale/_authenticated/analytics-move/certifications';
import { Route as LocaleAuthenticatedAdminOverviewRouteImport } from './routes/$locale/_authenticated/admin/overview';
import { Route as LocaleAuthenticatedAdminDatabaseRouteImport } from './routes/$locale/_authenticated/admin/database';
import { Route as LocaleAuthenticatedAnalyticsWeeklyRouteRouteImport } from './routes/$locale/_authenticated/analytics/weekly/route';
import { Route as LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteImport } from './routes/$locale/_authenticated/analytics-move/weekly/route';
import { Route as LocaleAuthenticatedAdminSettingsRouteRouteImport } from './routes/$locale/_authenticated/admin/settings/route';
import { Route as LocaleAuthenticatedInstructorCoursesIndexRouteImport } from './routes/$locale/_authenticated/instructor/courses/index';
import { Route as LocaleAuthenticatedCrmMembershipsIndexRouteImport } from './routes/$locale/_authenticated/crm/memberships/index';
import { Route as LocaleAuthenticatedCrmHelpdeskIndexRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/index';
import { Route as LocaleAuthenticatedAnalyticsWeeklyIndexRouteImport } from './routes/$locale/_authenticated/analytics/weekly/index';
import { Route as LocaleAuthenticatedAnalyticsMoveWeeklyIndexRouteImport } from './routes/$locale/_authenticated/analytics-move/weekly/index';
import { Route as LocaleAuthenticatedAdminSettingsIndexRouteImport } from './routes/$locale/_authenticated/admin/settings/index';
import { Route as LocaleAuthenticatedStudentDocumentsDocumentIdRouteImport } from './routes/$locale/_authenticated/student/documents/$documentId';
import { Route as LocaleAuthenticatedStudentCoursesCourseIdRouteImport } from './routes/$locale/_authenticated/student/courses/$courseId';
import { Route as LocaleAuthenticatedInstructorCoursesCourseIdRouteImport } from './routes/$locale/_authenticated/instructor/courses/$courseId';
import { Route as LocaleAuthenticatedCrmMembershipsMembershipIdRouteImport } from './routes/$locale/_authenticated/crm/memberships/$membershipId';
import { Route as LocaleAuthenticatedCrmHelpdeskSettingsRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/settings';
import { Route as LocaleAuthenticatedCrmHelpdeskPromptsRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/prompts';
import { Route as LocaleAuthenticatedCrmHelpdeskInstructionsRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/instructions';
import { Route as LocaleAuthenticatedCrmHelpdeskArticlesRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/articles';
import { Route as LocaleAuthenticatedCrmHelpdeskTaskUuidRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/$taskUuid';
import { Route as LocaleAuthenticatedCrmCoursesCourseIdRouteImport } from './routes/$locale/_authenticated/crm/courses/$courseId';
import { Route as LocaleAuthenticatedAnalyticsWeeklyWeekIdRouteImport } from './routes/$locale/_authenticated/analytics/weekly/$weekId';
import { Route as LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRouteImport } from './routes/$locale/_authenticated/analytics-move/weekly/$weekId';
import { Route as LocaleAuthenticatedAdminSettingsHelpdeskRouteImport } from './routes/$locale/_authenticated/admin/settings/helpdesk';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/route';
import { Route as LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteImport } from './routes/$locale/_authenticated/crm/customers/$customerId/route';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/index';
import { Route as LocaleAuthenticatedCrmHelpdeskPromptsIndexRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/prompts/index';
import { Route as LocaleAuthenticatedCrmHelpdeskInstructionsIndexRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/instructions/index';
import { Route as LocaleAuthenticatedCrmHelpdeskArticlesIndexRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/articles/index';
import { Route as LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRouteImport } from './routes/$locale/_authenticated/student/onboarding/activities/$activityKey';
import { Route as LocaleAuthenticatedStudentEducationModulesModuleIdRouteImport } from './routes/$locale/_authenticated/student/education/modules/$moduleId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/training';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/sync';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/payments';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/membership';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/helpdesk';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/documents';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey';
import { Route as LocaleAuthenticatedCrmHelpdeskPromptsNewRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/prompts/new';
import { Route as LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/prompts/$promptId';
import { Route as LocaleAuthenticatedCrmHelpdeskInstructionsNewRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/instructions/new';
import { Route as LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/instructions/$instructionId';
import { Route as LocaleAuthenticatedCrmHelpdeskArticlesNewRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/articles/new';
import { Route as LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRouteImport } from './routes/$locale/_authenticated/crm/helpdesk/articles/$articleId';
import { Route as LocaleAuthenticatedCrmCustomersCustomerIdSplatRouteImport } from './routes/$locale/_authenticated/crm/customers/$customerId/$';
import { Route as LocaleAuthenticatedAdminSettingsOperationsSectionIdRouteImport } from './routes/$locale/_authenticated/admin/settings/operations/$sectionId';
import { Route as LocaleAuthenticatedAdminSettingsBusinessRolesRouteImport } from './routes/$locale/_authenticated/admin/settings/business/roles';
import { Route as LocaleAuthenticatedAdminSettingsBusinessLocationsRouteImport } from './routes/$locale/_authenticated/admin/settings/business/locations';
import { Route as LocaleAuthenticatedAdminSettingsBusinessSectionIdRouteImport } from './routes/$locale/_authenticated/admin/settings/business/$sectionId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/training/index';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/index';
import { Route as LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRouteImport } from './routes/$locale/_authenticated/student/registrations/$registrationId/activities/$activityKey';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/training/$programLogId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/$documentId';
import { Route as LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRouteImport } from './routes/$locale/_authenticated/admin/settings/operations/integrations/revenuecat';
import { Route as LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRouteImport } from './routes/$locale/_authenticated/admin/settings/operations/integrations/gmail';
import { Route as LocaleAuthenticatedAdminSettingsBusinessRolesAuditRouteImport } from './routes/$locale/_authenticated/admin/settings/business/roles/audit';
import { Route as LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRouteImport } from './routes/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes';
import { Route as LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRouteImport } from './routes/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups';
import { Route as LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRouteImport } from './routes/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/index';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/certifications/$certificationId';
import { Route as LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRouteImport } from './routes/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers';
import { Route as LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRouteImport } from './routes/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId_/completion-form/$documentId';

const LocaleAuthenticatedWarehouseReportsLazyRouteImport = createFileRoute(
  '/$locale/_authenticated/warehouse/reports',
)();

const HealthzRoute = HealthzRouteImport.update({
  id: '/healthz',
  path: '/healthz',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any);
const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRoute,
} as any);
const CertificatesCertificateLogIdRoute =
  CertificatesCertificateLogIdRouteImport.update({
    id: '/certificates/$certificateLogId',
    path: '/certificates/$certificateLogId',
    getParentRoute: () => rootRouteImport,
  } as any);
const LocaleHelpdeskRoute = LocaleHelpdeskRouteImport.update({
  id: '/$locale_/helpdesk',
  path: '/$locale/helpdesk',
  getParentRoute: () => rootRouteImport,
} as any);
const LocaleUnauthorizedRoute = LocaleUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleStudentRoute = LocaleStudentRouteImport.update({
  id: '/student',
  path: '/student',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleSignupRoute = LocaleSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleRequestLoginLinkRoute = LocaleRequestLoginLinkRouteImport.update({
  id: '/request-login-link',
  path: '/request-login-link',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleRegisterRoute = LocaleRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleLoginRoute = LocaleLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleInstructorGrowthOperatingSystemRoute =
  LocaleInstructorGrowthOperatingSystemRouteImport.update({
    id: '/instructor-growth-operating-system',
    path: '/instructor-growth-operating-system',
    getParentRoute: () => LocaleRoute,
  } as any);
const LocaleForgotPasswordRoute = LocaleForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleCliAuthRoute = LocaleCliAuthRouteImport.update({
  id: '/cli-auth',
  path: '/cli-auth',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleAuthenticatedRoute = LocaleAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleUiLibraryIndexRoute = LocaleUiLibraryIndexRouteImport.update({
  id: '/ui-library/',
  path: '/ui-library/',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleCoursesIndexRoute = LocaleCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleHelpdeskConnectRoute = LocaleHelpdeskConnectRouteImport.update({
  id: '/$locale_/helpdesk_/connect',
  path: '/$locale/helpdesk/connect',
  getParentRoute: () => rootRouteImport,
} as any);
const LocaleCoursesCourseIdRoute = LocaleCoursesCourseIdRouteImport.update({
  id: '/courses/$courseId',
  path: '/courses/$courseId',
  getParentRoute: () => LocaleRoute,
} as any);
const LocaleAuthenticatedTranslationsRoute =
  LocaleAuthenticatedTranslationsRouteImport.update({
    id: '/translations',
    path: '/translations',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedTeamDashboardRoute =
  LocaleAuthenticatedTeamDashboardRouteImport.update({
    id: '/team-dashboard',
    path: '/team-dashboard',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedPaymentsRoute =
  LocaleAuthenticatedPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedDashboardRoute =
  LocaleAuthenticatedDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAnalyticsGearRoute =
  LocaleAuthenticatedAnalyticsGearRouteImport.update({
    id: '/analytics-gear',
    path: '/analytics-gear',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAccountRoute =
  LocaleAuthenticatedAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedWarehouseRouteRoute =
  LocaleAuthenticatedWarehouseRouteRouteImport.update({
    id: '/warehouse',
    path: '/warehouse',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedSyncRouteRoute =
  LocaleAuthenticatedSyncRouteRouteImport.update({
    id: '/sync',
    path: '/sync',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/sync/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedStudentRouteRoute =
  LocaleAuthenticatedStudentRouteRouteImport.update({
    id: '/student',
    path: '/student',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/student/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedShopifyRouteRoute =
  LocaleAuthenticatedShopifyRouteRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedInstructorRouteRoute =
  LocaleAuthenticatedInstructorRouteRouteImport.update({
    id: '/instructor',
    path: '/instructor',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/instructor/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedGearErpRouteRoute =
  LocaleAuthenticatedGearErpRouteRouteImport.update({
    id: '/gear-erp',
    path: '/gear-erp',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedErpSyncRouteRoute =
  LocaleAuthenticatedErpSyncRouteRouteImport.update({
    id: '/erp-sync',
    path: '/erp-sync',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/erp-sync/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedAnalyticsMoveRouteRoute =
  LocaleAuthenticatedAnalyticsMoveRouteRouteImport.update({
    id: '/analytics-move',
    path: '/analytics-move',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/analytics-move/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedAnalyticsRouteRoute =
  LocaleAuthenticatedAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/analytics/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedAdminRouteRoute =
  LocaleAuthenticatedAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/admin/route.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedWarehouseIndexRoute =
  LocaleAuthenticatedWarehouseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedWarehouseRouteRoute,
  } as any);
const LocaleAuthenticatedSyncIndexRoute =
  LocaleAuthenticatedSyncIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedStudentIndexRoute =
  LocaleAuthenticatedStudentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedShopifyIndexRoute =
  LocaleAuthenticatedShopifyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedShopifyRouteRoute,
  } as any);
const LocaleAuthenticatedInstructorIndexRoute =
  LocaleAuthenticatedInstructorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedInstructorRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpIndexRoute =
  LocaleAuthenticatedGearErpIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncIndexRoute =
  LocaleAuthenticatedErpSyncIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedCrmIndexRoute =
  LocaleAuthenticatedCrmIndexRouteImport.update({
    id: '/crm/',
    path: '/crm/',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAnalyticsIndexRoute =
  LocaleAuthenticatedAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAnalyticsRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveIndexRoute =
  LocaleAuthenticatedAnalyticsMoveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAdminIndexRoute =
  LocaleAuthenticatedAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAdminRouteRoute,
  } as any);
const LocaleAuthenticatedWarehouseReportsLazyRoute =
  LocaleAuthenticatedWarehouseReportsLazyRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => LocaleAuthenticatedWarehouseRouteRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/warehouse/reports.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleRecoveryPasswordResetRecoveryRequestIdRoute =
  LocaleRecoveryPasswordResetRecoveryRequestIdRouteImport.update({
    id: '/recovery/password-reset/$recoveryRequestId',
    path: '/recovery/password-reset/$recoveryRequestId',
    getParentRoute: () => LocaleRoute,
  } as any);
const LocaleRecoveryLoginLinkRecoveryRequestIdRoute =
  LocaleRecoveryLoginLinkRecoveryRequestIdRouteImport.update({
    id: '/recovery/login-link/$recoveryRequestId',
    path: '/recovery/login-link/$recoveryRequestId',
    getParentRoute: () => LocaleRoute,
  } as any);
const LocaleAuthenticatedWarehouseWarehousesRoute =
  LocaleAuthenticatedWarehouseWarehousesRouteImport.update({
    id: '/warehouses',
    path: '/warehouses',
    getParentRoute: () => LocaleAuthenticatedWarehouseRouteRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/warehouse/warehouses.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedWarehouseInventoryRoute =
  LocaleAuthenticatedWarehouseInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => LocaleAuthenticatedWarehouseRouteRoute,
  } as any).lazy(() =>
    import('./routes/$locale/_authenticated/warehouse/inventory.lazy').then(
      (d) => d.Route,
    ),
  );
const LocaleAuthenticatedSyncSweepRunsRoute =
  LocaleAuthenticatedSyncSweepRunsRouteImport.update({
    id: '/sweep-runs',
    path: '/sweep-runs',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedSyncRelationQueueRoute =
  LocaleAuthenticatedSyncRelationQueueRouteImport.update({
    id: '/relation-queue',
    path: '/relation-queue',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedSyncOptionSetsRoute =
  LocaleAuthenticatedSyncOptionSetsRouteImport.update({
    id: '/option-sets',
    path: '/option-sets',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedSyncJobsRoute =
  LocaleAuthenticatedSyncJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedSyncDataTypesRoute =
  LocaleAuthenticatedSyncDataTypesRouteImport.update({
    id: '/data-types',
    path: '/data-types',
    getParentRoute: () => LocaleAuthenticatedSyncRouteRoute,
  } as any);
const LocaleAuthenticatedStudentProgressRoute =
  LocaleAuthenticatedStudentProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedStudentPersonalFlowRoute =
  LocaleAuthenticatedStudentPersonalFlowRouteImport.update({
    id: '/personal-flow',
    path: '/personal-flow',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedStudentMy_coursesRoute =
  LocaleAuthenticatedStudentMy_coursesRouteImport.update({
    id: '/my_courses',
    path: '/my_courses',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedShopifyStockControlRoute =
  LocaleAuthenticatedShopifyStockControlRouteImport.update({
    id: '/stock-control',
    path: '/stock-control',
    getParentRoute: () => LocaleAuthenticatedShopifyRouteRoute,
  } as any);
const LocaleAuthenticatedPaymentsPaymentIdRoute =
  LocaleAuthenticatedPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => LocaleAuthenticatedPaymentsRoute,
  } as any);
const LocaleAuthenticatedInstructorStudentsRoute =
  LocaleAuthenticatedInstructorStudentsRouteImport.update({
    id: '/students',
    path: '/students',
    getParentRoute: () => LocaleAuthenticatedInstructorRouteRoute,
  } as any);
const LocaleAuthenticatedInstructorDashboardRoute =
  LocaleAuthenticatedInstructorDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LocaleAuthenticatedInstructorRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpValidationRoute =
  LocaleAuthenticatedGearErpValidationRouteImport.update({
    id: '/validation',
    path: '/validation',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpRegistryRoute =
  LocaleAuthenticatedGearErpRegistryRouteImport.update({
    id: '/registry',
    path: '/registry',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpReadinessRoute =
  LocaleAuthenticatedGearErpReadinessRouteImport.update({
    id: '/readiness',
    path: '/readiness',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpProductsRoute =
  LocaleAuthenticatedGearErpProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpMigrationBatchesRoute =
  LocaleAuthenticatedGearErpMigrationBatchesRouteImport.update({
    id: '/migration-batches',
    path: '/migration-batches',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpMappingRoute =
  LocaleAuthenticatedGearErpMappingRouteImport.update({
    id: '/mapping',
    path: '/mapping',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpFailuresRoute =
  LocaleAuthenticatedGearErpFailuresRouteImport.update({
    id: '/failures',
    path: '/failures',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpEvidenceRoute =
  LocaleAuthenticatedGearErpEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedGearErpDataQualityRoute =
  LocaleAuthenticatedGearErpDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => LocaleAuthenticatedGearErpRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncValidationRoute =
  LocaleAuthenticatedErpSyncValidationRouteImport.update({
    id: '/validation',
    path: '/validation',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncRegistryRoute =
  LocaleAuthenticatedErpSyncRegistryRouteImport.update({
    id: '/registry',
    path: '/registry',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncReadinessRoute =
  LocaleAuthenticatedErpSyncReadinessRouteImport.update({
    id: '/readiness',
    path: '/readiness',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncMigrationBatchesRoute =
  LocaleAuthenticatedErpSyncMigrationBatchesRouteImport.update({
    id: '/migration-batches',
    path: '/migration-batches',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncMappingRoute =
  LocaleAuthenticatedErpSyncMappingRouteImport.update({
    id: '/mapping',
    path: '/mapping',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncFailuresRoute =
  LocaleAuthenticatedErpSyncFailuresRouteImport.update({
    id: '/failures',
    path: '/failures',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncEvidenceRoute =
  LocaleAuthenticatedErpSyncEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedErpSyncDataQualityRoute =
  LocaleAuthenticatedErpSyncDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => LocaleAuthenticatedErpSyncRouteRoute,
  } as any);
const LocaleAuthenticatedCrmSearchRoute =
  LocaleAuthenticatedCrmSearchRouteImport.update({
    id: '/crm/search',
    path: '/crm/search',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmAnalyticsRoute =
  LocaleAuthenticatedCrmAnalyticsRouteImport.update({
    id: '/crm/analytics',
    path: '/crm/analytics',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAnalyticsOverviewRoute =
  LocaleAuthenticatedAnalyticsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => LocaleAuthenticatedAnalyticsRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsGearExpressRoute =
  LocaleAuthenticatedAnalyticsGearExpressRouteImport.update({
    id: '/gear-express',
    path: '/gear-express',
    getParentRoute: () => LocaleAuthenticatedAnalyticsRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveTranslationsRoute =
  LocaleAuthenticatedAnalyticsMoveTranslationsRouteImport.update({
    id: '/translations',
    path: '/translations',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute =
  LocaleAuthenticatedAnalyticsMoveTrainingProgramsRouteImport.update({
    id: '/training-programs',
    path: '/training-programs',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveRevenueRoute =
  LocaleAuthenticatedAnalyticsMoveRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveRegistrationsRoute =
  LocaleAuthenticatedAnalyticsMoveRegistrationsRouteImport.update({
    id: '/registrations',
    path: '/registrations',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route =
  LocaleAuthenticatedAnalyticsMoveRegistrationTop30RouteImport.update({
    id: '/registration-top30',
    path: '/registration-top30',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveOverviewRoute =
  LocaleAuthenticatedAnalyticsMoveOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveMembershipRoute =
  LocaleAuthenticatedAnalyticsMoveMembershipRouteImport.update({
    id: '/membership',
    path: '/membership',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveMembersRoute =
  LocaleAuthenticatedAnalyticsMoveMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveMapsRoute =
  LocaleAuthenticatedAnalyticsMoveMapsRouteImport.update({
    id: '/maps',
    path: '/maps',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveMainLocationRoute =
  LocaleAuthenticatedAnalyticsMoveMainLocationRouteImport.update({
    id: '/main-location',
    path: '/main-location',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveEducationRoute =
  LocaleAuthenticatedAnalyticsMoveEducationRouteImport.update({
    id: '/education',
    path: '/education',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveCoursesRoute =
  LocaleAuthenticatedAnalyticsMoveCoursesRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveCertificationsRoute =
  LocaleAuthenticatedAnalyticsMoveCertificationsRouteImport.update({
    id: '/certifications',
    path: '/certifications',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAdminOverviewRoute =
  LocaleAuthenticatedAdminOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => LocaleAuthenticatedAdminRouteRoute,
  } as any);
const LocaleAuthenticatedAdminDatabaseRoute =
  LocaleAuthenticatedAdminDatabaseRouteImport.update({
    id: '/database',
    path: '/database',
    getParentRoute: () => LocaleAuthenticatedAdminRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsWeeklyRouteRoute =
  LocaleAuthenticatedAnalyticsWeeklyRouteRouteImport.update({
    id: '/weekly',
    path: '/weekly',
    getParentRoute: () => LocaleAuthenticatedAnalyticsRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute =
  LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteImport.update({
    id: '/weekly',
    path: '/weekly',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsRouteRoute =
  LocaleAuthenticatedAdminSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LocaleAuthenticatedAdminRouteRoute,
  } as any);
const LocaleAuthenticatedInstructorCoursesIndexRoute =
  LocaleAuthenticatedInstructorCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => LocaleAuthenticatedInstructorRouteRoute,
  } as any);
const LocaleAuthenticatedCrmMembershipsIndexRoute =
  LocaleAuthenticatedCrmMembershipsIndexRouteImport.update({
    id: '/crm/memberships/',
    path: '/crm/memberships/',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskIndexRoute =
  LocaleAuthenticatedCrmHelpdeskIndexRouteImport.update({
    id: '/crm/helpdesk/',
    path: '/crm/helpdesk/',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAnalyticsWeeklyIndexRoute =
  LocaleAuthenticatedAnalyticsWeeklyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAnalyticsWeeklyRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute =
  LocaleAuthenticatedAnalyticsMoveWeeklyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsIndexRoute =
  LocaleAuthenticatedAdminSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedStudentDocumentsDocumentIdRoute =
  LocaleAuthenticatedStudentDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedStudentCoursesCourseIdRoute =
  LocaleAuthenticatedStudentCoursesCourseIdRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedInstructorCoursesCourseIdRoute =
  LocaleAuthenticatedInstructorCoursesCourseIdRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => LocaleAuthenticatedInstructorRouteRoute,
  } as any);
const LocaleAuthenticatedCrmMembershipsMembershipIdRoute =
  LocaleAuthenticatedCrmMembershipsMembershipIdRouteImport.update({
    id: '/crm/memberships/$membershipId',
    path: '/crm/memberships/$membershipId',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskSettingsRoute =
  LocaleAuthenticatedCrmHelpdeskSettingsRouteImport.update({
    id: '/crm/helpdesk/settings',
    path: '/crm/helpdesk/settings',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskPromptsRoute =
  LocaleAuthenticatedCrmHelpdeskPromptsRouteImport.update({
    id: '/crm/helpdesk/prompts',
    path: '/crm/helpdesk/prompts',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskInstructionsRoute =
  LocaleAuthenticatedCrmHelpdeskInstructionsRouteImport.update({
    id: '/crm/helpdesk/instructions',
    path: '/crm/helpdesk/instructions',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskArticlesRoute =
  LocaleAuthenticatedCrmHelpdeskArticlesRouteImport.update({
    id: '/crm/helpdesk/articles',
    path: '/crm/helpdesk/articles',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskTaskUuidRoute =
  LocaleAuthenticatedCrmHelpdeskTaskUuidRouteImport.update({
    id: '/crm/helpdesk/$taskUuid',
    path: '/crm/helpdesk/$taskUuid',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmCoursesCourseIdRoute =
  LocaleAuthenticatedCrmCoursesCourseIdRouteImport.update({
    id: '/crm/courses/$courseId',
    path: '/crm/courses/$courseId',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute =
  LocaleAuthenticatedAnalyticsWeeklyWeekIdRouteImport.update({
    id: '/$weekId',
    path: '/$weekId',
    getParentRoute: () => LocaleAuthenticatedAnalyticsWeeklyRouteRoute,
  } as any);
const LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute =
  LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRouteImport.update({
    id: '/$weekId',
    path: '/$weekId',
    getParentRoute: () => LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsHelpdeskRoute =
  LocaleAuthenticatedAdminSettingsHelpdeskRouteImport.update({
    id: '/helpdesk',
    path: '/helpdesk',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteImport.update({
    id: '/crm/user-profiles/$userProfileId',
    path: '/crm/user-profiles/$userProfileId',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute =
  LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteImport.update({
    id: '/crm/customers/$customerId',
    path: '/crm/customers/$customerId',
    getParentRoute: () => LocaleAuthenticatedRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute =
  LocaleAuthenticatedCrmHelpdeskPromptsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskPromptsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute =
  LocaleAuthenticatedCrmHelpdeskInstructionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskInstructionsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute =
  LocaleAuthenticatedCrmHelpdeskArticlesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskArticlesRoute,
  } as any);
const LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute =
  LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRouteImport.update({
    id: '/onboarding/activities/$activityKey',
    path: '/onboarding/activities/$activityKey',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedStudentEducationModulesModuleIdRoute =
  LocaleAuthenticatedStudentEducationModulesModuleIdRouteImport.update({
    id: '/education/modules/$moduleId',
    path: '/education/modules/$moduleId',
    getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRouteImport.update({
    id: '/sync',
    path: '/sync',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRouteImport.update({
    id: '/membership',
    path: '/membership',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteImport.update({
    id: '/learning',
    path: '/learning',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRouteImport.update({
    id: '/helpdesk',
    path: '/helpdesk',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRouteImport.update({
    id: '/$areaKey',
    path: '/$areaKey',
    getParentRoute: () =>
      LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskPromptsNewRoute =
  LocaleAuthenticatedCrmHelpdeskPromptsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskPromptsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute =
  LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRouteImport.update({
    id: '/$promptId',
    path: '/$promptId',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskPromptsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute =
  LocaleAuthenticatedCrmHelpdeskInstructionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskInstructionsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute =
  LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRouteImport.update({
    id: '/$instructionId',
    path: '/$instructionId',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskInstructionsRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskArticlesNewRoute =
  LocaleAuthenticatedCrmHelpdeskArticlesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskArticlesRoute,
  } as any);
const LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute =
  LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRouteImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => LocaleAuthenticatedCrmHelpdeskArticlesRoute,
  } as any);
const LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute =
  LocaleAuthenticatedCrmCustomersCustomerIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute =
  LocaleAuthenticatedAdminSettingsOperationsSectionIdRouteImport.update({
    id: '/operations/$sectionId',
    path: '/operations/$sectionId',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsBusinessRolesRoute =
  LocaleAuthenticatedAdminSettingsBusinessRolesRouteImport.update({
    id: '/business/roles',
    path: '/business/roles',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsBusinessLocationsRoute =
  LocaleAuthenticatedAdminSettingsBusinessLocationsRouteImport.update({
    id: '/business/locations',
    path: '/business/locations',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute =
  LocaleAuthenticatedAdminSettingsBusinessSectionIdRouteImport.update({
    id: '/business/$sectionId',
    path: '/business/$sectionId',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
  } as any);
const LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );
const LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute =
  LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRouteImport.update(
    {
      id: '/registrations/$registrationId/activities/$activityKey',
      path: '/registrations/$registrationId/activities/$activityKey',
      getParentRoute: () => LocaleAuthenticatedStudentRouteRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRouteImport.update(
    {
      id: '/$programLogId',
      path: '/$programLogId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRouteImport.update(
    {
      id: '/$documentId',
      path: '/$documentId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute =
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRouteImport.update(
    {
      id: '/operations/integrations/revenuecat',
      path: '/operations/integrations/revenuecat',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute =
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRouteImport.update(
    {
      id: '/operations/integrations/gmail',
      path: '/operations/integrations/gmail',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute =
  LocaleAuthenticatedAdminSettingsBusinessRolesAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => LocaleAuthenticatedAdminSettingsBusinessRolesRoute,
  } as any);
const LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute =
  LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRouteImport.update(
    {
      id: '/business/communications-promotions/promocodes',
      path: '/business/communications-promotions/promocodes',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute =
  LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRouteImport.update(
    {
      id: '/business/communications-promotions/ad-popups',
      path: '/business/communications-promotions/ad-popups',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute =
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRouteImport.update(
    {
      id: '/operations/integrations/klaviyo/',
      path: '/operations/integrations/klaviyo/',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRouteImport.update(
    {
      id: '/registrations/$registrationId',
      path: '/registrations/$registrationId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRouteImport.update(
    {
      id: '/education-module-logs/$educationModuleLogId',
      path: '/education-module-logs/$educationModuleLogId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRouteImport.update(
    {
      id: '/courses/$courseId',
      path: '/courses/$courseId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRouteImport.update(
    {
      id: '/certifications/$certificationId',
      path: '/certifications/$certificationId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );
const LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute =
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRouteImport.update(
    {
      id: '/operations/integrations/klaviyo/event-triggers',
      path: '/operations/integrations/klaviyo/event-triggers',
      getParentRoute: () => LocaleAuthenticatedAdminSettingsRouteRoute,
    } as any,
  );
const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRouteImport.update(
    {
      id: '/registrations/$registrationId_/completion-form/$documentId',
      path: '/registrations/$registrationId/completion-form/$documentId',
      getParentRoute: () =>
        LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/$locale': typeof LocaleAuthenticatedRouteWithChildren;
  '/dashboard': typeof DashboardRoute;
  '/healthz': typeof HealthzRoute;
  '/$locale/cli-auth': typeof LocaleCliAuthRoute;
  '/$locale/forgot-password': typeof LocaleForgotPasswordRoute;
  '/$locale/instructor-growth-operating-system': typeof LocaleInstructorGrowthOperatingSystemRoute;
  '/$locale/login': typeof LocaleLoginRoute;
  '/$locale/register': typeof LocaleRegisterRoute;
  '/$locale/request-login-link': typeof LocaleRequestLoginLinkRoute;
  '/$locale/signup': typeof LocaleSignupRoute;
  '/$locale/student': typeof LocaleAuthenticatedStudentRouteRouteWithChildren;
  '/$locale/unauthorized': typeof LocaleUnauthorizedRoute;
  '/$locale/helpdesk': typeof LocaleHelpdeskRoute;
  '/certificates/$certificateLogId': typeof CertificatesCertificateLogIdRoute;
  '/$locale/': typeof LocaleIndexRoute;
  '/$locale/admin': typeof LocaleAuthenticatedAdminRouteRouteWithChildren;
  '/$locale/analytics': typeof LocaleAuthenticatedAnalyticsRouteRouteWithChildren;
  '/$locale/analytics-move': typeof LocaleAuthenticatedAnalyticsMoveRouteRouteWithChildren;
  '/$locale/erp-sync': typeof LocaleAuthenticatedErpSyncRouteRouteWithChildren;
  '/$locale/gear-erp': typeof LocaleAuthenticatedGearErpRouteRouteWithChildren;
  '/$locale/instructor': typeof LocaleAuthenticatedInstructorRouteRouteWithChildren;
  '/$locale/shopify': typeof LocaleAuthenticatedShopifyRouteRouteWithChildren;
  '/$locale/sync': typeof LocaleAuthenticatedSyncRouteRouteWithChildren;
  '/$locale/warehouse': typeof LocaleAuthenticatedWarehouseRouteRouteWithChildren;
  '/$locale/account': typeof LocaleAuthenticatedAccountRoute;
  '/$locale/analytics-gear': typeof LocaleAuthenticatedAnalyticsGearRoute;
  '/$locale/dashboard': typeof LocaleAuthenticatedDashboardRoute;
  '/$locale/payments': typeof LocaleAuthenticatedPaymentsRouteWithChildren;
  '/$locale/team-dashboard': typeof LocaleAuthenticatedTeamDashboardRoute;
  '/$locale/translations': typeof LocaleAuthenticatedTranslationsRoute;
  '/$locale/courses/$courseId': typeof LocaleCoursesCourseIdRoute;
  '/$locale/helpdesk/connect': typeof LocaleHelpdeskConnectRoute;
  '/$locale/courses': typeof LocaleCoursesIndexRoute;
  '/$locale/ui-library': typeof LocaleUiLibraryIndexRoute;
  '/$locale/admin/settings': typeof LocaleAuthenticatedAdminSettingsRouteRouteWithChildren;
  '/$locale/analytics-move/weekly': typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteWithChildren;
  '/$locale/analytics/weekly': typeof LocaleAuthenticatedAnalyticsWeeklyRouteRouteWithChildren;
  '/$locale/admin/database': typeof LocaleAuthenticatedAdminDatabaseRoute;
  '/$locale/admin/overview': typeof LocaleAuthenticatedAdminOverviewRoute;
  '/$locale/analytics-move/certifications': typeof LocaleAuthenticatedAnalyticsMoveCertificationsRoute;
  '/$locale/analytics-move/courses': typeof LocaleAuthenticatedAnalyticsMoveCoursesRoute;
  '/$locale/analytics-move/education': typeof LocaleAuthenticatedAnalyticsMoveEducationRoute;
  '/$locale/analytics-move/main-location': typeof LocaleAuthenticatedAnalyticsMoveMainLocationRoute;
  '/$locale/analytics-move/maps': typeof LocaleAuthenticatedAnalyticsMoveMapsRoute;
  '/$locale/analytics-move/members': typeof LocaleAuthenticatedAnalyticsMoveMembersRoute;
  '/$locale/analytics-move/membership': typeof LocaleAuthenticatedAnalyticsMoveMembershipRoute;
  '/$locale/analytics-move/overview': typeof LocaleAuthenticatedAnalyticsMoveOverviewRoute;
  '/$locale/analytics-move/registration-top30': typeof LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route;
  '/$locale/analytics-move/registrations': typeof LocaleAuthenticatedAnalyticsMoveRegistrationsRoute;
  '/$locale/analytics-move/revenue': typeof LocaleAuthenticatedAnalyticsMoveRevenueRoute;
  '/$locale/analytics-move/training-programs': typeof LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute;
  '/$locale/analytics-move/translations': typeof LocaleAuthenticatedAnalyticsMoveTranslationsRoute;
  '/$locale/analytics/gear-express': typeof LocaleAuthenticatedAnalyticsGearExpressRoute;
  '/$locale/analytics/overview': typeof LocaleAuthenticatedAnalyticsOverviewRoute;
  '/$locale/crm/analytics': typeof LocaleAuthenticatedCrmAnalyticsRoute;
  '/$locale/crm/search': typeof LocaleAuthenticatedCrmSearchRoute;
  '/$locale/erp-sync/data-quality': typeof LocaleAuthenticatedErpSyncDataQualityRoute;
  '/$locale/erp-sync/evidence': typeof LocaleAuthenticatedErpSyncEvidenceRoute;
  '/$locale/erp-sync/failures': typeof LocaleAuthenticatedErpSyncFailuresRoute;
  '/$locale/erp-sync/mapping': typeof LocaleAuthenticatedErpSyncMappingRoute;
  '/$locale/erp-sync/migration-batches': typeof LocaleAuthenticatedErpSyncMigrationBatchesRoute;
  '/$locale/erp-sync/readiness': typeof LocaleAuthenticatedErpSyncReadinessRoute;
  '/$locale/erp-sync/registry': typeof LocaleAuthenticatedErpSyncRegistryRoute;
  '/$locale/erp-sync/validation': typeof LocaleAuthenticatedErpSyncValidationRoute;
  '/$locale/gear-erp/data-quality': typeof LocaleAuthenticatedGearErpDataQualityRoute;
  '/$locale/gear-erp/evidence': typeof LocaleAuthenticatedGearErpEvidenceRoute;
  '/$locale/gear-erp/failures': typeof LocaleAuthenticatedGearErpFailuresRoute;
  '/$locale/gear-erp/mapping': typeof LocaleAuthenticatedGearErpMappingRoute;
  '/$locale/gear-erp/migration-batches': typeof LocaleAuthenticatedGearErpMigrationBatchesRoute;
  '/$locale/gear-erp/products': typeof LocaleAuthenticatedGearErpProductsRoute;
  '/$locale/gear-erp/readiness': typeof LocaleAuthenticatedGearErpReadinessRoute;
  '/$locale/gear-erp/registry': typeof LocaleAuthenticatedGearErpRegistryRoute;
  '/$locale/gear-erp/validation': typeof LocaleAuthenticatedGearErpValidationRoute;
  '/$locale/instructor/dashboard': typeof LocaleAuthenticatedInstructorDashboardRoute;
  '/$locale/instructor/students': typeof LocaleAuthenticatedInstructorStudentsRoute;
  '/$locale/payments/$paymentId': typeof LocaleAuthenticatedPaymentsPaymentIdRoute;
  '/$locale/shopify/stock-control': typeof LocaleAuthenticatedShopifyStockControlRoute;
  '/$locale/student/my_courses': typeof LocaleAuthenticatedStudentMy_coursesRoute;
  '/$locale/student/personal-flow': typeof LocaleAuthenticatedStudentPersonalFlowRoute;
  '/$locale/student/progress': typeof LocaleAuthenticatedStudentProgressRoute;
  '/$locale/sync/data-types': typeof LocaleAuthenticatedSyncDataTypesRoute;
  '/$locale/sync/jobs': typeof LocaleAuthenticatedSyncJobsRoute;
  '/$locale/sync/option-sets': typeof LocaleAuthenticatedSyncOptionSetsRoute;
  '/$locale/sync/relation-queue': typeof LocaleAuthenticatedSyncRelationQueueRoute;
  '/$locale/sync/sweep-runs': typeof LocaleAuthenticatedSyncSweepRunsRoute;
  '/$locale/warehouse/inventory': typeof LocaleAuthenticatedWarehouseInventoryRoute;
  '/$locale/warehouse/warehouses': typeof LocaleAuthenticatedWarehouseWarehousesRoute;
  '/$locale/recovery/login-link/$recoveryRequestId': typeof LocaleRecoveryLoginLinkRecoveryRequestIdRoute;
  '/$locale/recovery/password-reset/$recoveryRequestId': typeof LocaleRecoveryPasswordResetRecoveryRequestIdRoute;
  '/$locale/warehouse/reports': typeof LocaleAuthenticatedWarehouseReportsLazyRoute;
  '/$locale/admin/': typeof LocaleAuthenticatedAdminIndexRoute;
  '/$locale/analytics-move/': typeof LocaleAuthenticatedAnalyticsMoveIndexRoute;
  '/$locale/analytics/': typeof LocaleAuthenticatedAnalyticsIndexRoute;
  '/$locale/crm': typeof LocaleAuthenticatedCrmIndexRoute;
  '/$locale/erp-sync/': typeof LocaleAuthenticatedErpSyncIndexRoute;
  '/$locale/gear-erp/': typeof LocaleAuthenticatedGearErpIndexRoute;
  '/$locale/instructor/': typeof LocaleAuthenticatedInstructorIndexRoute;
  '/$locale/shopify/': typeof LocaleAuthenticatedShopifyIndexRoute;
  '/$locale/student/': typeof LocaleAuthenticatedStudentIndexRoute;
  '/$locale/sync/': typeof LocaleAuthenticatedSyncIndexRoute;
  '/$locale/warehouse/': typeof LocaleAuthenticatedWarehouseIndexRoute;
  '/$locale/crm/customers/$customerId': typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren;
  '/$locale/crm/user-profiles/$userProfileId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteWithChildren;
  '/$locale/admin/settings/helpdesk': typeof LocaleAuthenticatedAdminSettingsHelpdeskRoute;
  '/$locale/analytics-move/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute;
  '/$locale/analytics/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute;
  '/$locale/crm/courses/$courseId': typeof LocaleAuthenticatedCrmCoursesCourseIdRoute;
  '/$locale/crm/helpdesk/$taskUuid': typeof LocaleAuthenticatedCrmHelpdeskTaskUuidRoute;
  '/$locale/crm/helpdesk/articles': typeof LocaleAuthenticatedCrmHelpdeskArticlesRouteWithChildren;
  '/$locale/crm/helpdesk/instructions': typeof LocaleAuthenticatedCrmHelpdeskInstructionsRouteWithChildren;
  '/$locale/crm/helpdesk/prompts': typeof LocaleAuthenticatedCrmHelpdeskPromptsRouteWithChildren;
  '/$locale/crm/helpdesk/settings': typeof LocaleAuthenticatedCrmHelpdeskSettingsRoute;
  '/$locale/crm/memberships/$membershipId': typeof LocaleAuthenticatedCrmMembershipsMembershipIdRoute;
  '/$locale/instructor/courses/$courseId': typeof LocaleAuthenticatedInstructorCoursesCourseIdRoute;
  '/$locale/student/courses/$courseId': typeof LocaleAuthenticatedStudentCoursesCourseIdRoute;
  '/$locale/student/documents/$documentId': typeof LocaleAuthenticatedStudentDocumentsDocumentIdRoute;
  '/$locale/admin/settings/': typeof LocaleAuthenticatedAdminSettingsIndexRoute;
  '/$locale/analytics-move/weekly/': typeof LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute;
  '/$locale/analytics/weekly/': typeof LocaleAuthenticatedAnalyticsWeeklyIndexRoute;
  '/$locale/crm/helpdesk': typeof LocaleAuthenticatedCrmHelpdeskIndexRoute;
  '/$locale/crm/memberships': typeof LocaleAuthenticatedCrmMembershipsIndexRoute;
  '/$locale/instructor/courses': typeof LocaleAuthenticatedInstructorCoursesIndexRoute;
  '/$locale/admin/settings/business/$sectionId': typeof LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute;
  '/$locale/admin/settings/business/locations': typeof LocaleAuthenticatedAdminSettingsBusinessLocationsRoute;
  '/$locale/admin/settings/business/roles': typeof LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren;
  '/$locale/admin/settings/operations/$sectionId': typeof LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute;
  '/$locale/crm/customers/$customerId/$': typeof LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute;
  '/$locale/crm/helpdesk/articles/$articleId': typeof LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute;
  '/$locale/crm/helpdesk/articles/new': typeof LocaleAuthenticatedCrmHelpdeskArticlesNewRoute;
  '/$locale/crm/helpdesk/instructions/$instructionId': typeof LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute;
  '/$locale/crm/helpdesk/instructions/new': typeof LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute;
  '/$locale/crm/helpdesk/prompts/$promptId': typeof LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute;
  '/$locale/crm/helpdesk/prompts/new': typeof LocaleAuthenticatedCrmHelpdeskPromptsNewRoute;
  '/$locale/crm/user-profiles/$userProfileId/$areaKey': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren;
  '/$locale/crm/user-profiles/$userProfileId/helpdesk': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteWithChildren;
  '/$locale/crm/user-profiles/$userProfileId/membership': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute;
  '/$locale/crm/user-profiles/$userProfileId/payments': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute;
  '/$locale/crm/user-profiles/$userProfileId/sync': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute;
  '/$locale/crm/user-profiles/$userProfileId/training': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteWithChildren;
  '/$locale/student/education/modules/$moduleId': typeof LocaleAuthenticatedStudentEducationModulesModuleIdRoute;
  '/$locale/student/onboarding/activities/$activityKey': typeof LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute;
  '/$locale/crm/helpdesk/articles/': typeof LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute;
  '/$locale/crm/helpdesk/instructions/': typeof LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute;
  '/$locale/crm/helpdesk/prompts/': typeof LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute;
  '/$locale/admin/settings/business/communications-promotions/ad-popups': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute;
  '/$locale/admin/settings/business/communications-promotions/promocodes': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute;
  '/$locale/admin/settings/business/roles/audit': typeof LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute;
  '/$locale/admin/settings/operations/integrations/gmail': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute;
  '/$locale/admin/settings/operations/integrations/revenuecat': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents/new': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute;
  '/$locale/crm/user-profiles/$userProfileId/training/$programLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute;
  '/$locale/student/registrations/$registrationId/activities/$activityKey': typeof LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId/training/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute;
  '/$locale/admin/settings/operations/integrations/klaviyo/event-triggers': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/certifications/$certificationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/courses/$courseId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute;
  '/$locale/admin/settings/operations/integrations/klaviyo': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId/completion-form/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/dashboard': typeof DashboardRoute;
  '/healthz': typeof HealthzRoute;
  '/$locale': typeof LocaleIndexRoute;
  '/$locale/cli-auth': typeof LocaleCliAuthRoute;
  '/$locale/forgot-password': typeof LocaleForgotPasswordRoute;
  '/$locale/instructor-growth-operating-system': typeof LocaleInstructorGrowthOperatingSystemRoute;
  '/$locale/login': typeof LocaleLoginRoute;
  '/$locale/register': typeof LocaleRegisterRoute;
  '/$locale/request-login-link': typeof LocaleRequestLoginLinkRoute;
  '/$locale/signup': typeof LocaleSignupRoute;
  '/$locale/student': typeof LocaleAuthenticatedStudentIndexRoute;
  '/$locale/unauthorized': typeof LocaleUnauthorizedRoute;
  '/$locale/helpdesk': typeof LocaleHelpdeskRoute;
  '/certificates/$certificateLogId': typeof CertificatesCertificateLogIdRoute;
  '/$locale/account': typeof LocaleAuthenticatedAccountRoute;
  '/$locale/analytics-gear': typeof LocaleAuthenticatedAnalyticsGearRoute;
  '/$locale/dashboard': typeof LocaleAuthenticatedDashboardRoute;
  '/$locale/payments': typeof LocaleAuthenticatedPaymentsRouteWithChildren;
  '/$locale/team-dashboard': typeof LocaleAuthenticatedTeamDashboardRoute;
  '/$locale/translations': typeof LocaleAuthenticatedTranslationsRoute;
  '/$locale/courses/$courseId': typeof LocaleCoursesCourseIdRoute;
  '/$locale/helpdesk/connect': typeof LocaleHelpdeskConnectRoute;
  '/$locale/courses': typeof LocaleCoursesIndexRoute;
  '/$locale/ui-library': typeof LocaleUiLibraryIndexRoute;
  '/$locale/admin/database': typeof LocaleAuthenticatedAdminDatabaseRoute;
  '/$locale/admin/overview': typeof LocaleAuthenticatedAdminOverviewRoute;
  '/$locale/analytics-move/certifications': typeof LocaleAuthenticatedAnalyticsMoveCertificationsRoute;
  '/$locale/analytics-move/courses': typeof LocaleAuthenticatedAnalyticsMoveCoursesRoute;
  '/$locale/analytics-move/education': typeof LocaleAuthenticatedAnalyticsMoveEducationRoute;
  '/$locale/analytics-move/main-location': typeof LocaleAuthenticatedAnalyticsMoveMainLocationRoute;
  '/$locale/analytics-move/maps': typeof LocaleAuthenticatedAnalyticsMoveMapsRoute;
  '/$locale/analytics-move/members': typeof LocaleAuthenticatedAnalyticsMoveMembersRoute;
  '/$locale/analytics-move/membership': typeof LocaleAuthenticatedAnalyticsMoveMembershipRoute;
  '/$locale/analytics-move/overview': typeof LocaleAuthenticatedAnalyticsMoveOverviewRoute;
  '/$locale/analytics-move/registration-top30': typeof LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route;
  '/$locale/analytics-move/registrations': typeof LocaleAuthenticatedAnalyticsMoveRegistrationsRoute;
  '/$locale/analytics-move/revenue': typeof LocaleAuthenticatedAnalyticsMoveRevenueRoute;
  '/$locale/analytics-move/training-programs': typeof LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute;
  '/$locale/analytics-move/translations': typeof LocaleAuthenticatedAnalyticsMoveTranslationsRoute;
  '/$locale/analytics/gear-express': typeof LocaleAuthenticatedAnalyticsGearExpressRoute;
  '/$locale/analytics/overview': typeof LocaleAuthenticatedAnalyticsOverviewRoute;
  '/$locale/crm/analytics': typeof LocaleAuthenticatedCrmAnalyticsRoute;
  '/$locale/crm/search': typeof LocaleAuthenticatedCrmSearchRoute;
  '/$locale/erp-sync/data-quality': typeof LocaleAuthenticatedErpSyncDataQualityRoute;
  '/$locale/erp-sync/evidence': typeof LocaleAuthenticatedErpSyncEvidenceRoute;
  '/$locale/erp-sync/failures': typeof LocaleAuthenticatedErpSyncFailuresRoute;
  '/$locale/erp-sync/mapping': typeof LocaleAuthenticatedErpSyncMappingRoute;
  '/$locale/erp-sync/migration-batches': typeof LocaleAuthenticatedErpSyncMigrationBatchesRoute;
  '/$locale/erp-sync/readiness': typeof LocaleAuthenticatedErpSyncReadinessRoute;
  '/$locale/erp-sync/registry': typeof LocaleAuthenticatedErpSyncRegistryRoute;
  '/$locale/erp-sync/validation': typeof LocaleAuthenticatedErpSyncValidationRoute;
  '/$locale/gear-erp/data-quality': typeof LocaleAuthenticatedGearErpDataQualityRoute;
  '/$locale/gear-erp/evidence': typeof LocaleAuthenticatedGearErpEvidenceRoute;
  '/$locale/gear-erp/failures': typeof LocaleAuthenticatedGearErpFailuresRoute;
  '/$locale/gear-erp/mapping': typeof LocaleAuthenticatedGearErpMappingRoute;
  '/$locale/gear-erp/migration-batches': typeof LocaleAuthenticatedGearErpMigrationBatchesRoute;
  '/$locale/gear-erp/products': typeof LocaleAuthenticatedGearErpProductsRoute;
  '/$locale/gear-erp/readiness': typeof LocaleAuthenticatedGearErpReadinessRoute;
  '/$locale/gear-erp/registry': typeof LocaleAuthenticatedGearErpRegistryRoute;
  '/$locale/gear-erp/validation': typeof LocaleAuthenticatedGearErpValidationRoute;
  '/$locale/instructor/dashboard': typeof LocaleAuthenticatedInstructorDashboardRoute;
  '/$locale/instructor/students': typeof LocaleAuthenticatedInstructorStudentsRoute;
  '/$locale/payments/$paymentId': typeof LocaleAuthenticatedPaymentsPaymentIdRoute;
  '/$locale/shopify/stock-control': typeof LocaleAuthenticatedShopifyStockControlRoute;
  '/$locale/student/my_courses': typeof LocaleAuthenticatedStudentMy_coursesRoute;
  '/$locale/student/personal-flow': typeof LocaleAuthenticatedStudentPersonalFlowRoute;
  '/$locale/student/progress': typeof LocaleAuthenticatedStudentProgressRoute;
  '/$locale/sync/data-types': typeof LocaleAuthenticatedSyncDataTypesRoute;
  '/$locale/sync/jobs': typeof LocaleAuthenticatedSyncJobsRoute;
  '/$locale/sync/option-sets': typeof LocaleAuthenticatedSyncOptionSetsRoute;
  '/$locale/sync/relation-queue': typeof LocaleAuthenticatedSyncRelationQueueRoute;
  '/$locale/sync/sweep-runs': typeof LocaleAuthenticatedSyncSweepRunsRoute;
  '/$locale/warehouse/inventory': typeof LocaleAuthenticatedWarehouseInventoryRoute;
  '/$locale/warehouse/warehouses': typeof LocaleAuthenticatedWarehouseWarehousesRoute;
  '/$locale/recovery/login-link/$recoveryRequestId': typeof LocaleRecoveryLoginLinkRecoveryRequestIdRoute;
  '/$locale/recovery/password-reset/$recoveryRequestId': typeof LocaleRecoveryPasswordResetRecoveryRequestIdRoute;
  '/$locale/warehouse/reports': typeof LocaleAuthenticatedWarehouseReportsLazyRoute;
  '/$locale/admin': typeof LocaleAuthenticatedAdminIndexRoute;
  '/$locale/analytics-move': typeof LocaleAuthenticatedAnalyticsMoveIndexRoute;
  '/$locale/analytics': typeof LocaleAuthenticatedAnalyticsIndexRoute;
  '/$locale/crm': typeof LocaleAuthenticatedCrmIndexRoute;
  '/$locale/erp-sync': typeof LocaleAuthenticatedErpSyncIndexRoute;
  '/$locale/gear-erp': typeof LocaleAuthenticatedGearErpIndexRoute;
  '/$locale/instructor': typeof LocaleAuthenticatedInstructorIndexRoute;
  '/$locale/shopify': typeof LocaleAuthenticatedShopifyIndexRoute;
  '/$locale/sync': typeof LocaleAuthenticatedSyncIndexRoute;
  '/$locale/warehouse': typeof LocaleAuthenticatedWarehouseIndexRoute;
  '/$locale/crm/customers/$customerId': typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren;
  '/$locale/admin/settings/helpdesk': typeof LocaleAuthenticatedAdminSettingsHelpdeskRoute;
  '/$locale/analytics-move/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute;
  '/$locale/analytics/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute;
  '/$locale/crm/courses/$courseId': typeof LocaleAuthenticatedCrmCoursesCourseIdRoute;
  '/$locale/crm/helpdesk/$taskUuid': typeof LocaleAuthenticatedCrmHelpdeskTaskUuidRoute;
  '/$locale/crm/helpdesk/settings': typeof LocaleAuthenticatedCrmHelpdeskSettingsRoute;
  '/$locale/crm/memberships/$membershipId': typeof LocaleAuthenticatedCrmMembershipsMembershipIdRoute;
  '/$locale/instructor/courses/$courseId': typeof LocaleAuthenticatedInstructorCoursesCourseIdRoute;
  '/$locale/student/courses/$courseId': typeof LocaleAuthenticatedStudentCoursesCourseIdRoute;
  '/$locale/student/documents/$documentId': typeof LocaleAuthenticatedStudentDocumentsDocumentIdRoute;
  '/$locale/admin/settings': typeof LocaleAuthenticatedAdminSettingsIndexRoute;
  '/$locale/analytics-move/weekly': typeof LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute;
  '/$locale/analytics/weekly': typeof LocaleAuthenticatedAnalyticsWeeklyIndexRoute;
  '/$locale/crm/helpdesk': typeof LocaleAuthenticatedCrmHelpdeskIndexRoute;
  '/$locale/crm/memberships': typeof LocaleAuthenticatedCrmMembershipsIndexRoute;
  '/$locale/instructor/courses': typeof LocaleAuthenticatedInstructorCoursesIndexRoute;
  '/$locale/admin/settings/business/$sectionId': typeof LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute;
  '/$locale/admin/settings/business/locations': typeof LocaleAuthenticatedAdminSettingsBusinessLocationsRoute;
  '/$locale/admin/settings/business/roles': typeof LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren;
  '/$locale/admin/settings/operations/$sectionId': typeof LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute;
  '/$locale/crm/customers/$customerId/$': typeof LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute;
  '/$locale/crm/helpdesk/articles/$articleId': typeof LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute;
  '/$locale/crm/helpdesk/articles/new': typeof LocaleAuthenticatedCrmHelpdeskArticlesNewRoute;
  '/$locale/crm/helpdesk/instructions/$instructionId': typeof LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute;
  '/$locale/crm/helpdesk/instructions/new': typeof LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute;
  '/$locale/crm/helpdesk/prompts/$promptId': typeof LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute;
  '/$locale/crm/helpdesk/prompts/new': typeof LocaleAuthenticatedCrmHelpdeskPromptsNewRoute;
  '/$locale/crm/user-profiles/$userProfileId/$areaKey': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren;
  '/$locale/crm/user-profiles/$userProfileId/helpdesk': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute;
  '/$locale/crm/user-profiles/$userProfileId/membership': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute;
  '/$locale/crm/user-profiles/$userProfileId/payments': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute;
  '/$locale/crm/user-profiles/$userProfileId/sync': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute;
  '/$locale/student/education/modules/$moduleId': typeof LocaleAuthenticatedStudentEducationModulesModuleIdRoute;
  '/$locale/student/onboarding/activities/$activityKey': typeof LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute;
  '/$locale/crm/helpdesk/articles': typeof LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute;
  '/$locale/crm/helpdesk/instructions': typeof LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute;
  '/$locale/crm/helpdesk/prompts': typeof LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute;
  '/$locale/admin/settings/business/communications-promotions/ad-popups': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute;
  '/$locale/admin/settings/business/communications-promotions/promocodes': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute;
  '/$locale/admin/settings/business/roles/audit': typeof LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute;
  '/$locale/admin/settings/operations/integrations/gmail': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute;
  '/$locale/admin/settings/operations/integrations/revenuecat': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/documents/new': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute;
  '/$locale/crm/user-profiles/$userProfileId/training/$programLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute;
  '/$locale/student/registrations/$registrationId/activities/$activityKey': typeof LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId/training': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute;
  '/$locale/admin/settings/operations/integrations/klaviyo/event-triggers': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/certifications/$certificationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/courses/$courseId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute;
  '/$locale/admin/settings/operations/integrations/klaviyo': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute;
  '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId/completion-form/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/$locale': typeof LocaleRouteWithChildren;
  '/dashboard': typeof DashboardRoute;
  '/healthz': typeof HealthzRoute;
  '/$locale/_authenticated': typeof LocaleAuthenticatedRouteWithChildren;
  '/$locale/cli-auth': typeof LocaleCliAuthRoute;
  '/$locale/forgot-password': typeof LocaleForgotPasswordRoute;
  '/$locale/instructor-growth-operating-system': typeof LocaleInstructorGrowthOperatingSystemRoute;
  '/$locale/login': typeof LocaleLoginRoute;
  '/$locale/register': typeof LocaleRegisterRoute;
  '/$locale/request-login-link': typeof LocaleRequestLoginLinkRoute;
  '/$locale/signup': typeof LocaleSignupRoute;
  '/$locale/student': typeof LocaleStudentRoute;
  '/$locale/unauthorized': typeof LocaleUnauthorizedRoute;
  '/$locale_/helpdesk': typeof LocaleHelpdeskRoute;
  '/certificates/$certificateLogId': typeof CertificatesCertificateLogIdRoute;
  '/$locale/': typeof LocaleIndexRoute;
  '/$locale/_authenticated/admin': typeof LocaleAuthenticatedAdminRouteRouteWithChildren;
  '/$locale/_authenticated/analytics': typeof LocaleAuthenticatedAnalyticsRouteRouteWithChildren;
  '/$locale/_authenticated/analytics-move': typeof LocaleAuthenticatedAnalyticsMoveRouteRouteWithChildren;
  '/$locale/_authenticated/erp-sync': typeof LocaleAuthenticatedErpSyncRouteRouteWithChildren;
  '/$locale/_authenticated/gear-erp': typeof LocaleAuthenticatedGearErpRouteRouteWithChildren;
  '/$locale/_authenticated/instructor': typeof LocaleAuthenticatedInstructorRouteRouteWithChildren;
  '/$locale/_authenticated/shopify': typeof LocaleAuthenticatedShopifyRouteRouteWithChildren;
  '/$locale/_authenticated/student': typeof LocaleAuthenticatedStudentRouteRouteWithChildren;
  '/$locale/_authenticated/sync': typeof LocaleAuthenticatedSyncRouteRouteWithChildren;
  '/$locale/_authenticated/warehouse': typeof LocaleAuthenticatedWarehouseRouteRouteWithChildren;
  '/$locale/_authenticated/account': typeof LocaleAuthenticatedAccountRoute;
  '/$locale/_authenticated/analytics-gear': typeof LocaleAuthenticatedAnalyticsGearRoute;
  '/$locale/_authenticated/dashboard': typeof LocaleAuthenticatedDashboardRoute;
  '/$locale/_authenticated/payments': typeof LocaleAuthenticatedPaymentsRouteWithChildren;
  '/$locale/_authenticated/team-dashboard': typeof LocaleAuthenticatedTeamDashboardRoute;
  '/$locale/_authenticated/translations': typeof LocaleAuthenticatedTranslationsRoute;
  '/$locale/courses/$courseId': typeof LocaleCoursesCourseIdRoute;
  '/$locale_/helpdesk_/connect': typeof LocaleHelpdeskConnectRoute;
  '/$locale/courses/': typeof LocaleCoursesIndexRoute;
  '/$locale/ui-library/': typeof LocaleUiLibraryIndexRoute;
  '/$locale/_authenticated/admin/settings': typeof LocaleAuthenticatedAdminSettingsRouteRouteWithChildren;
  '/$locale/_authenticated/analytics-move/weekly': typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteWithChildren;
  '/$locale/_authenticated/analytics/weekly': typeof LocaleAuthenticatedAnalyticsWeeklyRouteRouteWithChildren;
  '/$locale/_authenticated/admin/database': typeof LocaleAuthenticatedAdminDatabaseRoute;
  '/$locale/_authenticated/admin/overview': typeof LocaleAuthenticatedAdminOverviewRoute;
  '/$locale/_authenticated/analytics-move/certifications': typeof LocaleAuthenticatedAnalyticsMoveCertificationsRoute;
  '/$locale/_authenticated/analytics-move/courses': typeof LocaleAuthenticatedAnalyticsMoveCoursesRoute;
  '/$locale/_authenticated/analytics-move/education': typeof LocaleAuthenticatedAnalyticsMoveEducationRoute;
  '/$locale/_authenticated/analytics-move/main-location': typeof LocaleAuthenticatedAnalyticsMoveMainLocationRoute;
  '/$locale/_authenticated/analytics-move/maps': typeof LocaleAuthenticatedAnalyticsMoveMapsRoute;
  '/$locale/_authenticated/analytics-move/members': typeof LocaleAuthenticatedAnalyticsMoveMembersRoute;
  '/$locale/_authenticated/analytics-move/membership': typeof LocaleAuthenticatedAnalyticsMoveMembershipRoute;
  '/$locale/_authenticated/analytics-move/overview': typeof LocaleAuthenticatedAnalyticsMoveOverviewRoute;
  '/$locale/_authenticated/analytics-move/registration-top30': typeof LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route;
  '/$locale/_authenticated/analytics-move/registrations': typeof LocaleAuthenticatedAnalyticsMoveRegistrationsRoute;
  '/$locale/_authenticated/analytics-move/revenue': typeof LocaleAuthenticatedAnalyticsMoveRevenueRoute;
  '/$locale/_authenticated/analytics-move/training-programs': typeof LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute;
  '/$locale/_authenticated/analytics-move/translations': typeof LocaleAuthenticatedAnalyticsMoveTranslationsRoute;
  '/$locale/_authenticated/analytics/gear-express': typeof LocaleAuthenticatedAnalyticsGearExpressRoute;
  '/$locale/_authenticated/analytics/overview': typeof LocaleAuthenticatedAnalyticsOverviewRoute;
  '/$locale/_authenticated/crm/analytics': typeof LocaleAuthenticatedCrmAnalyticsRoute;
  '/$locale/_authenticated/crm/search': typeof LocaleAuthenticatedCrmSearchRoute;
  '/$locale/_authenticated/erp-sync/data-quality': typeof LocaleAuthenticatedErpSyncDataQualityRoute;
  '/$locale/_authenticated/erp-sync/evidence': typeof LocaleAuthenticatedErpSyncEvidenceRoute;
  '/$locale/_authenticated/erp-sync/failures': typeof LocaleAuthenticatedErpSyncFailuresRoute;
  '/$locale/_authenticated/erp-sync/mapping': typeof LocaleAuthenticatedErpSyncMappingRoute;
  '/$locale/_authenticated/erp-sync/migration-batches': typeof LocaleAuthenticatedErpSyncMigrationBatchesRoute;
  '/$locale/_authenticated/erp-sync/readiness': typeof LocaleAuthenticatedErpSyncReadinessRoute;
  '/$locale/_authenticated/erp-sync/registry': typeof LocaleAuthenticatedErpSyncRegistryRoute;
  '/$locale/_authenticated/erp-sync/validation': typeof LocaleAuthenticatedErpSyncValidationRoute;
  '/$locale/_authenticated/gear-erp/data-quality': typeof LocaleAuthenticatedGearErpDataQualityRoute;
  '/$locale/_authenticated/gear-erp/evidence': typeof LocaleAuthenticatedGearErpEvidenceRoute;
  '/$locale/_authenticated/gear-erp/failures': typeof LocaleAuthenticatedGearErpFailuresRoute;
  '/$locale/_authenticated/gear-erp/mapping': typeof LocaleAuthenticatedGearErpMappingRoute;
  '/$locale/_authenticated/gear-erp/migration-batches': typeof LocaleAuthenticatedGearErpMigrationBatchesRoute;
  '/$locale/_authenticated/gear-erp/products': typeof LocaleAuthenticatedGearErpProductsRoute;
  '/$locale/_authenticated/gear-erp/readiness': typeof LocaleAuthenticatedGearErpReadinessRoute;
  '/$locale/_authenticated/gear-erp/registry': typeof LocaleAuthenticatedGearErpRegistryRoute;
  '/$locale/_authenticated/gear-erp/validation': typeof LocaleAuthenticatedGearErpValidationRoute;
  '/$locale/_authenticated/instructor/dashboard': typeof LocaleAuthenticatedInstructorDashboardRoute;
  '/$locale/_authenticated/instructor/students': typeof LocaleAuthenticatedInstructorStudentsRoute;
  '/$locale/_authenticated/payments/$paymentId': typeof LocaleAuthenticatedPaymentsPaymentIdRoute;
  '/$locale/_authenticated/shopify/stock-control': typeof LocaleAuthenticatedShopifyStockControlRoute;
  '/$locale/_authenticated/student/my_courses': typeof LocaleAuthenticatedStudentMy_coursesRoute;
  '/$locale/_authenticated/student/personal-flow': typeof LocaleAuthenticatedStudentPersonalFlowRoute;
  '/$locale/_authenticated/student/progress': typeof LocaleAuthenticatedStudentProgressRoute;
  '/$locale/_authenticated/sync/data-types': typeof LocaleAuthenticatedSyncDataTypesRoute;
  '/$locale/_authenticated/sync/jobs': typeof LocaleAuthenticatedSyncJobsRoute;
  '/$locale/_authenticated/sync/option-sets': typeof LocaleAuthenticatedSyncOptionSetsRoute;
  '/$locale/_authenticated/sync/relation-queue': typeof LocaleAuthenticatedSyncRelationQueueRoute;
  '/$locale/_authenticated/sync/sweep-runs': typeof LocaleAuthenticatedSyncSweepRunsRoute;
  '/$locale/_authenticated/warehouse/inventory': typeof LocaleAuthenticatedWarehouseInventoryRoute;
  '/$locale/_authenticated/warehouse/warehouses': typeof LocaleAuthenticatedWarehouseWarehousesRoute;
  '/$locale/recovery/login-link/$recoveryRequestId': typeof LocaleRecoveryLoginLinkRecoveryRequestIdRoute;
  '/$locale/recovery/password-reset/$recoveryRequestId': typeof LocaleRecoveryPasswordResetRecoveryRequestIdRoute;
  '/$locale/_authenticated/warehouse/reports': typeof LocaleAuthenticatedWarehouseReportsLazyRoute;
  '/$locale/_authenticated/admin/': typeof LocaleAuthenticatedAdminIndexRoute;
  '/$locale/_authenticated/analytics-move/': typeof LocaleAuthenticatedAnalyticsMoveIndexRoute;
  '/$locale/_authenticated/analytics/': typeof LocaleAuthenticatedAnalyticsIndexRoute;
  '/$locale/_authenticated/crm/': typeof LocaleAuthenticatedCrmIndexRoute;
  '/$locale/_authenticated/erp-sync/': typeof LocaleAuthenticatedErpSyncIndexRoute;
  '/$locale/_authenticated/gear-erp/': typeof LocaleAuthenticatedGearErpIndexRoute;
  '/$locale/_authenticated/instructor/': typeof LocaleAuthenticatedInstructorIndexRoute;
  '/$locale/_authenticated/shopify/': typeof LocaleAuthenticatedShopifyIndexRoute;
  '/$locale/_authenticated/student/': typeof LocaleAuthenticatedStudentIndexRoute;
  '/$locale/_authenticated/sync/': typeof LocaleAuthenticatedSyncIndexRoute;
  '/$locale/_authenticated/warehouse/': typeof LocaleAuthenticatedWarehouseIndexRoute;
  '/$locale/_authenticated/crm/customers/$customerId': typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteWithChildren;
  '/$locale/_authenticated/admin/settings/helpdesk': typeof LocaleAuthenticatedAdminSettingsHelpdeskRoute;
  '/$locale/_authenticated/analytics-move/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute;
  '/$locale/_authenticated/analytics/weekly/$weekId': typeof LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute;
  '/$locale/_authenticated/crm/courses/$courseId': typeof LocaleAuthenticatedCrmCoursesCourseIdRoute;
  '/$locale/_authenticated/crm/helpdesk/$taskUuid': typeof LocaleAuthenticatedCrmHelpdeskTaskUuidRoute;
  '/$locale/_authenticated/crm/helpdesk/articles': typeof LocaleAuthenticatedCrmHelpdeskArticlesRouteWithChildren;
  '/$locale/_authenticated/crm/helpdesk/instructions': typeof LocaleAuthenticatedCrmHelpdeskInstructionsRouteWithChildren;
  '/$locale/_authenticated/crm/helpdesk/prompts': typeof LocaleAuthenticatedCrmHelpdeskPromptsRouteWithChildren;
  '/$locale/_authenticated/crm/helpdesk/settings': typeof LocaleAuthenticatedCrmHelpdeskSettingsRoute;
  '/$locale/_authenticated/crm/memberships/$membershipId': typeof LocaleAuthenticatedCrmMembershipsMembershipIdRoute;
  '/$locale/_authenticated/instructor/courses/$courseId': typeof LocaleAuthenticatedInstructorCoursesCourseIdRoute;
  '/$locale/_authenticated/student/courses/$courseId': typeof LocaleAuthenticatedStudentCoursesCourseIdRoute;
  '/$locale/_authenticated/student/documents/$documentId': typeof LocaleAuthenticatedStudentDocumentsDocumentIdRoute;
  '/$locale/_authenticated/admin/settings/': typeof LocaleAuthenticatedAdminSettingsIndexRoute;
  '/$locale/_authenticated/analytics-move/weekly/': typeof LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute;
  '/$locale/_authenticated/analytics/weekly/': typeof LocaleAuthenticatedAnalyticsWeeklyIndexRoute;
  '/$locale/_authenticated/crm/helpdesk/': typeof LocaleAuthenticatedCrmHelpdeskIndexRoute;
  '/$locale/_authenticated/crm/memberships/': typeof LocaleAuthenticatedCrmMembershipsIndexRoute;
  '/$locale/_authenticated/instructor/courses/': typeof LocaleAuthenticatedInstructorCoursesIndexRoute;
  '/$locale/_authenticated/admin/settings/business/$sectionId': typeof LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute;
  '/$locale/_authenticated/admin/settings/business/locations': typeof LocaleAuthenticatedAdminSettingsBusinessLocationsRoute;
  '/$locale/_authenticated/admin/settings/business/roles': typeof LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren;
  '/$locale/_authenticated/admin/settings/operations/$sectionId': typeof LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute;
  '/$locale/_authenticated/crm/customers/$customerId/$': typeof LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute;
  '/$locale/_authenticated/crm/helpdesk/articles/$articleId': typeof LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute;
  '/$locale/_authenticated/crm/helpdesk/articles/new': typeof LocaleAuthenticatedCrmHelpdeskArticlesNewRoute;
  '/$locale/_authenticated/crm/helpdesk/instructions/$instructionId': typeof LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute;
  '/$locale/_authenticated/crm/helpdesk/instructions/new': typeof LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute;
  '/$locale/_authenticated/crm/helpdesk/prompts/$promptId': typeof LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute;
  '/$locale/_authenticated/crm/helpdesk/prompts/new': typeof LocaleAuthenticatedCrmHelpdeskPromptsNewRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/helpdesk': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteWithChildren;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/membership': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/payments': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/sync': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/training': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteWithChildren;
  '/$locale/_authenticated/student/education/modules/$moduleId': typeof LocaleAuthenticatedStudentEducationModulesModuleIdRoute;
  '/$locale/_authenticated/student/onboarding/activities/$activityKey': typeof LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute;
  '/$locale/_authenticated/crm/helpdesk/articles/': typeof LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute;
  '/$locale/_authenticated/crm/helpdesk/instructions/': typeof LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute;
  '/$locale/_authenticated/crm/helpdesk/prompts/': typeof LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute;
  '/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute;
  '/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes': typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute;
  '/$locale/_authenticated/admin/settings/business/roles/audit': typeof LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute;
  '/$locale/_authenticated/admin/settings/operations/integrations/gmail': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute;
  '/$locale/_authenticated/admin/settings/operations/integrations/revenuecat': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/$programLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute;
  '/$locale/_authenticated/student/registrations/$registrationId/activities/$activityKey': typeof LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute;
  '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/certifications/$certificationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute;
  '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/': typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute;
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId_/completion-form/$documentId': typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/$locale'
    | '/dashboard'
    | '/healthz'
    | '/$locale/cli-auth'
    | '/$locale/forgot-password'
    | '/$locale/instructor-growth-operating-system'
    | '/$locale/login'
    | '/$locale/register'
    | '/$locale/request-login-link'
    | '/$locale/signup'
    | '/$locale/student'
    | '/$locale/unauthorized'
    | '/$locale/helpdesk'
    | '/certificates/$certificateLogId'
    | '/$locale/'
    | '/$locale/admin'
    | '/$locale/analytics'
    | '/$locale/analytics-move'
    | '/$locale/erp-sync'
    | '/$locale/gear-erp'
    | '/$locale/instructor'
    | '/$locale/shopify'
    | '/$locale/sync'
    | '/$locale/warehouse'
    | '/$locale/account'
    | '/$locale/analytics-gear'
    | '/$locale/dashboard'
    | '/$locale/payments'
    | '/$locale/team-dashboard'
    | '/$locale/translations'
    | '/$locale/courses/$courseId'
    | '/$locale/helpdesk/connect'
    | '/$locale/courses'
    | '/$locale/ui-library'
    | '/$locale/admin/settings'
    | '/$locale/analytics-move/weekly'
    | '/$locale/analytics/weekly'
    | '/$locale/admin/database'
    | '/$locale/admin/overview'
    | '/$locale/analytics-move/certifications'
    | '/$locale/analytics-move/courses'
    | '/$locale/analytics-move/education'
    | '/$locale/analytics-move/main-location'
    | '/$locale/analytics-move/maps'
    | '/$locale/analytics-move/members'
    | '/$locale/analytics-move/membership'
    | '/$locale/analytics-move/overview'
    | '/$locale/analytics-move/registration-top30'
    | '/$locale/analytics-move/registrations'
    | '/$locale/analytics-move/revenue'
    | '/$locale/analytics-move/training-programs'
    | '/$locale/analytics-move/translations'
    | '/$locale/analytics/gear-express'
    | '/$locale/analytics/overview'
    | '/$locale/crm/analytics'
    | '/$locale/crm/search'
    | '/$locale/erp-sync/data-quality'
    | '/$locale/erp-sync/evidence'
    | '/$locale/erp-sync/failures'
    | '/$locale/erp-sync/mapping'
    | '/$locale/erp-sync/migration-batches'
    | '/$locale/erp-sync/readiness'
    | '/$locale/erp-sync/registry'
    | '/$locale/erp-sync/validation'
    | '/$locale/gear-erp/data-quality'
    | '/$locale/gear-erp/evidence'
    | '/$locale/gear-erp/failures'
    | '/$locale/gear-erp/mapping'
    | '/$locale/gear-erp/migration-batches'
    | '/$locale/gear-erp/products'
    | '/$locale/gear-erp/readiness'
    | '/$locale/gear-erp/registry'
    | '/$locale/gear-erp/validation'
    | '/$locale/instructor/dashboard'
    | '/$locale/instructor/students'
    | '/$locale/payments/$paymentId'
    | '/$locale/shopify/stock-control'
    | '/$locale/student/my_courses'
    | '/$locale/student/personal-flow'
    | '/$locale/student/progress'
    | '/$locale/sync/data-types'
    | '/$locale/sync/jobs'
    | '/$locale/sync/option-sets'
    | '/$locale/sync/relation-queue'
    | '/$locale/sync/sweep-runs'
    | '/$locale/warehouse/inventory'
    | '/$locale/warehouse/warehouses'
    | '/$locale/recovery/login-link/$recoveryRequestId'
    | '/$locale/recovery/password-reset/$recoveryRequestId'
    | '/$locale/warehouse/reports'
    | '/$locale/admin/'
    | '/$locale/analytics-move/'
    | '/$locale/analytics/'
    | '/$locale/crm'
    | '/$locale/erp-sync/'
    | '/$locale/gear-erp/'
    | '/$locale/instructor/'
    | '/$locale/shopify/'
    | '/$locale/student/'
    | '/$locale/sync/'
    | '/$locale/warehouse/'
    | '/$locale/crm/customers/$customerId'
    | '/$locale/crm/user-profiles/$userProfileId'
    | '/$locale/admin/settings/helpdesk'
    | '/$locale/analytics-move/weekly/$weekId'
    | '/$locale/analytics/weekly/$weekId'
    | '/$locale/crm/courses/$courseId'
    | '/$locale/crm/helpdesk/$taskUuid'
    | '/$locale/crm/helpdesk/articles'
    | '/$locale/crm/helpdesk/instructions'
    | '/$locale/crm/helpdesk/prompts'
    | '/$locale/crm/helpdesk/settings'
    | '/$locale/crm/memberships/$membershipId'
    | '/$locale/instructor/courses/$courseId'
    | '/$locale/student/courses/$courseId'
    | '/$locale/student/documents/$documentId'
    | '/$locale/admin/settings/'
    | '/$locale/analytics-move/weekly/'
    | '/$locale/analytics/weekly/'
    | '/$locale/crm/helpdesk'
    | '/$locale/crm/memberships'
    | '/$locale/instructor/courses'
    | '/$locale/admin/settings/business/$sectionId'
    | '/$locale/admin/settings/business/locations'
    | '/$locale/admin/settings/business/roles'
    | '/$locale/admin/settings/operations/$sectionId'
    | '/$locale/crm/customers/$customerId/$'
    | '/$locale/crm/helpdesk/articles/$articleId'
    | '/$locale/crm/helpdesk/articles/new'
    | '/$locale/crm/helpdesk/instructions/$instructionId'
    | '/$locale/crm/helpdesk/instructions/new'
    | '/$locale/crm/helpdesk/prompts/$promptId'
    | '/$locale/crm/helpdesk/prompts/new'
    | '/$locale/crm/user-profiles/$userProfileId/$areaKey'
    | '/$locale/crm/user-profiles/$userProfileId/documents'
    | '/$locale/crm/user-profiles/$userProfileId/helpdesk'
    | '/$locale/crm/user-profiles/$userProfileId/learning'
    | '/$locale/crm/user-profiles/$userProfileId/membership'
    | '/$locale/crm/user-profiles/$userProfileId/payments'
    | '/$locale/crm/user-profiles/$userProfileId/sync'
    | '/$locale/crm/user-profiles/$userProfileId/training'
    | '/$locale/student/education/modules/$moduleId'
    | '/$locale/student/onboarding/activities/$activityKey'
    | '/$locale/crm/helpdesk/articles/'
    | '/$locale/crm/helpdesk/instructions/'
    | '/$locale/crm/helpdesk/prompts/'
    | '/$locale/crm/user-profiles/$userProfileId/'
    | '/$locale/admin/settings/business/communications-promotions/ad-popups'
    | '/$locale/admin/settings/business/communications-promotions/promocodes'
    | '/$locale/admin/settings/business/roles/audit'
    | '/$locale/admin/settings/operations/integrations/gmail'
    | '/$locale/admin/settings/operations/integrations/revenuecat'
    | '/$locale/crm/user-profiles/$userProfileId/documents/$documentId'
    | '/$locale/crm/user-profiles/$userProfileId/documents/new'
    | '/$locale/crm/user-profiles/$userProfileId/training/$programLogId'
    | '/$locale/student/registrations/$registrationId/activities/$activityKey'
    | '/$locale/crm/user-profiles/$userProfileId/learning/'
    | '/$locale/crm/user-profiles/$userProfileId/training/'
    | '/$locale/admin/settings/operations/integrations/klaviyo/event-triggers'
    | '/$locale/crm/user-profiles/$userProfileId/learning/certifications/$certificationId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/courses/$courseId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId'
    | '/$locale/admin/settings/operations/integrations/klaviyo'
    | '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId/completion-form/$documentId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/dashboard'
    | '/healthz'
    | '/$locale'
    | '/$locale/cli-auth'
    | '/$locale/forgot-password'
    | '/$locale/instructor-growth-operating-system'
    | '/$locale/login'
    | '/$locale/register'
    | '/$locale/request-login-link'
    | '/$locale/signup'
    | '/$locale/student'
    | '/$locale/unauthorized'
    | '/$locale/helpdesk'
    | '/certificates/$certificateLogId'
    | '/$locale/account'
    | '/$locale/analytics-gear'
    | '/$locale/dashboard'
    | '/$locale/payments'
    | '/$locale/team-dashboard'
    | '/$locale/translations'
    | '/$locale/courses/$courseId'
    | '/$locale/helpdesk/connect'
    | '/$locale/courses'
    | '/$locale/ui-library'
    | '/$locale/admin/database'
    | '/$locale/admin/overview'
    | '/$locale/analytics-move/certifications'
    | '/$locale/analytics-move/courses'
    | '/$locale/analytics-move/education'
    | '/$locale/analytics-move/main-location'
    | '/$locale/analytics-move/maps'
    | '/$locale/analytics-move/members'
    | '/$locale/analytics-move/membership'
    | '/$locale/analytics-move/overview'
    | '/$locale/analytics-move/registration-top30'
    | '/$locale/analytics-move/registrations'
    | '/$locale/analytics-move/revenue'
    | '/$locale/analytics-move/training-programs'
    | '/$locale/analytics-move/translations'
    | '/$locale/analytics/gear-express'
    | '/$locale/analytics/overview'
    | '/$locale/crm/analytics'
    | '/$locale/crm/search'
    | '/$locale/erp-sync/data-quality'
    | '/$locale/erp-sync/evidence'
    | '/$locale/erp-sync/failures'
    | '/$locale/erp-sync/mapping'
    | '/$locale/erp-sync/migration-batches'
    | '/$locale/erp-sync/readiness'
    | '/$locale/erp-sync/registry'
    | '/$locale/erp-sync/validation'
    | '/$locale/gear-erp/data-quality'
    | '/$locale/gear-erp/evidence'
    | '/$locale/gear-erp/failures'
    | '/$locale/gear-erp/mapping'
    | '/$locale/gear-erp/migration-batches'
    | '/$locale/gear-erp/products'
    | '/$locale/gear-erp/readiness'
    | '/$locale/gear-erp/registry'
    | '/$locale/gear-erp/validation'
    | '/$locale/instructor/dashboard'
    | '/$locale/instructor/students'
    | '/$locale/payments/$paymentId'
    | '/$locale/shopify/stock-control'
    | '/$locale/student/my_courses'
    | '/$locale/student/personal-flow'
    | '/$locale/student/progress'
    | '/$locale/sync/data-types'
    | '/$locale/sync/jobs'
    | '/$locale/sync/option-sets'
    | '/$locale/sync/relation-queue'
    | '/$locale/sync/sweep-runs'
    | '/$locale/warehouse/inventory'
    | '/$locale/warehouse/warehouses'
    | '/$locale/recovery/login-link/$recoveryRequestId'
    | '/$locale/recovery/password-reset/$recoveryRequestId'
    | '/$locale/warehouse/reports'
    | '/$locale/admin'
    | '/$locale/analytics-move'
    | '/$locale/analytics'
    | '/$locale/crm'
    | '/$locale/erp-sync'
    | '/$locale/gear-erp'
    | '/$locale/instructor'
    | '/$locale/shopify'
    | '/$locale/sync'
    | '/$locale/warehouse'
    | '/$locale/crm/customers/$customerId'
    | '/$locale/admin/settings/helpdesk'
    | '/$locale/analytics-move/weekly/$weekId'
    | '/$locale/analytics/weekly/$weekId'
    | '/$locale/crm/courses/$courseId'
    | '/$locale/crm/helpdesk/$taskUuid'
    | '/$locale/crm/helpdesk/settings'
    | '/$locale/crm/memberships/$membershipId'
    | '/$locale/instructor/courses/$courseId'
    | '/$locale/student/courses/$courseId'
    | '/$locale/student/documents/$documentId'
    | '/$locale/admin/settings'
    | '/$locale/analytics-move/weekly'
    | '/$locale/analytics/weekly'
    | '/$locale/crm/helpdesk'
    | '/$locale/crm/memberships'
    | '/$locale/instructor/courses'
    | '/$locale/admin/settings/business/$sectionId'
    | '/$locale/admin/settings/business/locations'
    | '/$locale/admin/settings/business/roles'
    | '/$locale/admin/settings/operations/$sectionId'
    | '/$locale/crm/customers/$customerId/$'
    | '/$locale/crm/helpdesk/articles/$articleId'
    | '/$locale/crm/helpdesk/articles/new'
    | '/$locale/crm/helpdesk/instructions/$instructionId'
    | '/$locale/crm/helpdesk/instructions/new'
    | '/$locale/crm/helpdesk/prompts/$promptId'
    | '/$locale/crm/helpdesk/prompts/new'
    | '/$locale/crm/user-profiles/$userProfileId/$areaKey'
    | '/$locale/crm/user-profiles/$userProfileId/documents'
    | '/$locale/crm/user-profiles/$userProfileId/helpdesk'
    | '/$locale/crm/user-profiles/$userProfileId/membership'
    | '/$locale/crm/user-profiles/$userProfileId/payments'
    | '/$locale/crm/user-profiles/$userProfileId/sync'
    | '/$locale/student/education/modules/$moduleId'
    | '/$locale/student/onboarding/activities/$activityKey'
    | '/$locale/crm/helpdesk/articles'
    | '/$locale/crm/helpdesk/instructions'
    | '/$locale/crm/helpdesk/prompts'
    | '/$locale/crm/user-profiles/$userProfileId'
    | '/$locale/admin/settings/business/communications-promotions/ad-popups'
    | '/$locale/admin/settings/business/communications-promotions/promocodes'
    | '/$locale/admin/settings/business/roles/audit'
    | '/$locale/admin/settings/operations/integrations/gmail'
    | '/$locale/admin/settings/operations/integrations/revenuecat'
    | '/$locale/crm/user-profiles/$userProfileId/documents/$documentId'
    | '/$locale/crm/user-profiles/$userProfileId/documents/new'
    | '/$locale/crm/user-profiles/$userProfileId/training/$programLogId'
    | '/$locale/student/registrations/$registrationId/activities/$activityKey'
    | '/$locale/crm/user-profiles/$userProfileId/learning'
    | '/$locale/crm/user-profiles/$userProfileId/training'
    | '/$locale/admin/settings/operations/integrations/klaviyo/event-triggers'
    | '/$locale/crm/user-profiles/$userProfileId/learning/certifications/$certificationId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/courses/$courseId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId'
    | '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId'
    | '/$locale/admin/settings/operations/integrations/klaviyo'
    | '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId/completion-form/$documentId';
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/dashboard'
    | '/healthz'
    | '/$locale/_authenticated'
    | '/$locale/cli-auth'
    | '/$locale/forgot-password'
    | '/$locale/instructor-growth-operating-system'
    | '/$locale/login'
    | '/$locale/register'
    | '/$locale/request-login-link'
    | '/$locale/signup'
    | '/$locale/student'
    | '/$locale/unauthorized'
    | '/$locale_/helpdesk'
    | '/certificates/$certificateLogId'
    | '/$locale/'
    | '/$locale/_authenticated/admin'
    | '/$locale/_authenticated/analytics'
    | '/$locale/_authenticated/analytics-move'
    | '/$locale/_authenticated/erp-sync'
    | '/$locale/_authenticated/gear-erp'
    | '/$locale/_authenticated/instructor'
    | '/$locale/_authenticated/shopify'
    | '/$locale/_authenticated/student'
    | '/$locale/_authenticated/sync'
    | '/$locale/_authenticated/warehouse'
    | '/$locale/_authenticated/account'
    | '/$locale/_authenticated/analytics-gear'
    | '/$locale/_authenticated/dashboard'
    | '/$locale/_authenticated/payments'
    | '/$locale/_authenticated/team-dashboard'
    | '/$locale/_authenticated/translations'
    | '/$locale/courses/$courseId'
    | '/$locale_/helpdesk_/connect'
    | '/$locale/courses/'
    | '/$locale/ui-library/'
    | '/$locale/_authenticated/admin/settings'
    | '/$locale/_authenticated/analytics-move/weekly'
    | '/$locale/_authenticated/analytics/weekly'
    | '/$locale/_authenticated/admin/database'
    | '/$locale/_authenticated/admin/overview'
    | '/$locale/_authenticated/analytics-move/certifications'
    | '/$locale/_authenticated/analytics-move/courses'
    | '/$locale/_authenticated/analytics-move/education'
    | '/$locale/_authenticated/analytics-move/main-location'
    | '/$locale/_authenticated/analytics-move/maps'
    | '/$locale/_authenticated/analytics-move/members'
    | '/$locale/_authenticated/analytics-move/membership'
    | '/$locale/_authenticated/analytics-move/overview'
    | '/$locale/_authenticated/analytics-move/registration-top30'
    | '/$locale/_authenticated/analytics-move/registrations'
    | '/$locale/_authenticated/analytics-move/revenue'
    | '/$locale/_authenticated/analytics-move/training-programs'
    | '/$locale/_authenticated/analytics-move/translations'
    | '/$locale/_authenticated/analytics/gear-express'
    | '/$locale/_authenticated/analytics/overview'
    | '/$locale/_authenticated/crm/analytics'
    | '/$locale/_authenticated/crm/search'
    | '/$locale/_authenticated/erp-sync/data-quality'
    | '/$locale/_authenticated/erp-sync/evidence'
    | '/$locale/_authenticated/erp-sync/failures'
    | '/$locale/_authenticated/erp-sync/mapping'
    | '/$locale/_authenticated/erp-sync/migration-batches'
    | '/$locale/_authenticated/erp-sync/readiness'
    | '/$locale/_authenticated/erp-sync/registry'
    | '/$locale/_authenticated/erp-sync/validation'
    | '/$locale/_authenticated/gear-erp/data-quality'
    | '/$locale/_authenticated/gear-erp/evidence'
    | '/$locale/_authenticated/gear-erp/failures'
    | '/$locale/_authenticated/gear-erp/mapping'
    | '/$locale/_authenticated/gear-erp/migration-batches'
    | '/$locale/_authenticated/gear-erp/products'
    | '/$locale/_authenticated/gear-erp/readiness'
    | '/$locale/_authenticated/gear-erp/registry'
    | '/$locale/_authenticated/gear-erp/validation'
    | '/$locale/_authenticated/instructor/dashboard'
    | '/$locale/_authenticated/instructor/students'
    | '/$locale/_authenticated/payments/$paymentId'
    | '/$locale/_authenticated/shopify/stock-control'
    | '/$locale/_authenticated/student/my_courses'
    | '/$locale/_authenticated/student/personal-flow'
    | '/$locale/_authenticated/student/progress'
    | '/$locale/_authenticated/sync/data-types'
    | '/$locale/_authenticated/sync/jobs'
    | '/$locale/_authenticated/sync/option-sets'
    | '/$locale/_authenticated/sync/relation-queue'
    | '/$locale/_authenticated/sync/sweep-runs'
    | '/$locale/_authenticated/warehouse/inventory'
    | '/$locale/_authenticated/warehouse/warehouses'
    | '/$locale/recovery/login-link/$recoveryRequestId'
    | '/$locale/recovery/password-reset/$recoveryRequestId'
    | '/$locale/_authenticated/warehouse/reports'
    | '/$locale/_authenticated/admin/'
    | '/$locale/_authenticated/analytics-move/'
    | '/$locale/_authenticated/analytics/'
    | '/$locale/_authenticated/crm/'
    | '/$locale/_authenticated/erp-sync/'
    | '/$locale/_authenticated/gear-erp/'
    | '/$locale/_authenticated/instructor/'
    | '/$locale/_authenticated/shopify/'
    | '/$locale/_authenticated/student/'
    | '/$locale/_authenticated/sync/'
    | '/$locale/_authenticated/warehouse/'
    | '/$locale/_authenticated/crm/customers/$customerId'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId'
    | '/$locale/_authenticated/admin/settings/helpdesk'
    | '/$locale/_authenticated/analytics-move/weekly/$weekId'
    | '/$locale/_authenticated/analytics/weekly/$weekId'
    | '/$locale/_authenticated/crm/courses/$courseId'
    | '/$locale/_authenticated/crm/helpdesk/$taskUuid'
    | '/$locale/_authenticated/crm/helpdesk/articles'
    | '/$locale/_authenticated/crm/helpdesk/instructions'
    | '/$locale/_authenticated/crm/helpdesk/prompts'
    | '/$locale/_authenticated/crm/helpdesk/settings'
    | '/$locale/_authenticated/crm/memberships/$membershipId'
    | '/$locale/_authenticated/instructor/courses/$courseId'
    | '/$locale/_authenticated/student/courses/$courseId'
    | '/$locale/_authenticated/student/documents/$documentId'
    | '/$locale/_authenticated/admin/settings/'
    | '/$locale/_authenticated/analytics-move/weekly/'
    | '/$locale/_authenticated/analytics/weekly/'
    | '/$locale/_authenticated/crm/helpdesk/'
    | '/$locale/_authenticated/crm/memberships/'
    | '/$locale/_authenticated/instructor/courses/'
    | '/$locale/_authenticated/admin/settings/business/$sectionId'
    | '/$locale/_authenticated/admin/settings/business/locations'
    | '/$locale/_authenticated/admin/settings/business/roles'
    | '/$locale/_authenticated/admin/settings/operations/$sectionId'
    | '/$locale/_authenticated/crm/customers/$customerId/$'
    | '/$locale/_authenticated/crm/helpdesk/articles/$articleId'
    | '/$locale/_authenticated/crm/helpdesk/articles/new'
    | '/$locale/_authenticated/crm/helpdesk/instructions/$instructionId'
    | '/$locale/_authenticated/crm/helpdesk/instructions/new'
    | '/$locale/_authenticated/crm/helpdesk/prompts/$promptId'
    | '/$locale/_authenticated/crm/helpdesk/prompts/new'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/helpdesk'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/membership'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/payments'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/sync'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/training'
    | '/$locale/_authenticated/student/education/modules/$moduleId'
    | '/$locale/_authenticated/student/onboarding/activities/$activityKey'
    | '/$locale/_authenticated/crm/helpdesk/articles/'
    | '/$locale/_authenticated/crm/helpdesk/instructions/'
    | '/$locale/_authenticated/crm/helpdesk/prompts/'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/'
    | '/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups'
    | '/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes'
    | '/$locale/_authenticated/admin/settings/business/roles/audit'
    | '/$locale/_authenticated/admin/settings/operations/integrations/gmail'
    | '/$locale/_authenticated/admin/settings/operations/integrations/revenuecat'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/$documentId'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/$programLogId'
    | '/$locale/_authenticated/student/registrations/$registrationId/activities/$activityKey'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/'
    | '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/certifications/$certificationId'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId'
    | '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/'
    | '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId_/completion-form/$documentId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LocaleRoute: typeof LocaleRouteWithChildren;
  DashboardRoute: typeof DashboardRoute;
  HealthzRoute: typeof HealthzRoute;
  LocaleHelpdeskRoute: typeof LocaleHelpdeskRoute;
  CertificatesCertificateLogIdRoute: typeof CertificatesCertificateLogIdRoute;
  LocaleHelpdeskConnectRoute: typeof LocaleHelpdeskConnectRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/healthz': {
      id: '/healthz';
      path: '/healthz';
      fullPath: '/healthz';
      preLoaderRoute: typeof HealthzRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dashboard': {
      id: '/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$locale': {
      id: '/$locale';
      path: '/$locale';
      fullPath: '/$locale';
      preLoaderRoute: typeof LocaleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$locale/': {
      id: '/$locale/';
      path: '/';
      fullPath: '/$locale/';
      preLoaderRoute: typeof LocaleIndexRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/certificates/$certificateLogId': {
      id: '/certificates/$certificateLogId';
      path: '/certificates/$certificateLogId';
      fullPath: '/certificates/$certificateLogId';
      preLoaderRoute: typeof CertificatesCertificateLogIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$locale_/helpdesk': {
      id: '/$locale_/helpdesk';
      path: '/$locale/helpdesk';
      fullPath: '/$locale/helpdesk';
      preLoaderRoute: typeof LocaleHelpdeskRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$locale/unauthorized': {
      id: '/$locale/unauthorized';
      path: '/unauthorized';
      fullPath: '/$locale/unauthorized';
      preLoaderRoute: typeof LocaleUnauthorizedRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/student': {
      id: '/$locale/student';
      path: '/student';
      fullPath: '/$locale/student';
      preLoaderRoute: typeof LocaleStudentRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/signup': {
      id: '/$locale/signup';
      path: '/signup';
      fullPath: '/$locale/signup';
      preLoaderRoute: typeof LocaleSignupRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/request-login-link': {
      id: '/$locale/request-login-link';
      path: '/request-login-link';
      fullPath: '/$locale/request-login-link';
      preLoaderRoute: typeof LocaleRequestLoginLinkRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/register': {
      id: '/$locale/register';
      path: '/register';
      fullPath: '/$locale/register';
      preLoaderRoute: typeof LocaleRegisterRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/login': {
      id: '/$locale/login';
      path: '/login';
      fullPath: '/$locale/login';
      preLoaderRoute: typeof LocaleLoginRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/instructor-growth-operating-system': {
      id: '/$locale/instructor-growth-operating-system';
      path: '/instructor-growth-operating-system';
      fullPath: '/$locale/instructor-growth-operating-system';
      preLoaderRoute: typeof LocaleInstructorGrowthOperatingSystemRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/forgot-password': {
      id: '/$locale/forgot-password';
      path: '/forgot-password';
      fullPath: '/$locale/forgot-password';
      preLoaderRoute: typeof LocaleForgotPasswordRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/cli-auth': {
      id: '/$locale/cli-auth';
      path: '/cli-auth';
      fullPath: '/$locale/cli-auth';
      preLoaderRoute: typeof LocaleCliAuthRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/_authenticated': {
      id: '/$locale/_authenticated';
      path: '';
      fullPath: '/$locale';
      preLoaderRoute: typeof LocaleAuthenticatedRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/ui-library/': {
      id: '/$locale/ui-library/';
      path: '/ui-library';
      fullPath: '/$locale/ui-library';
      preLoaderRoute: typeof LocaleUiLibraryIndexRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/courses/': {
      id: '/$locale/courses/';
      path: '/courses';
      fullPath: '/$locale/courses';
      preLoaderRoute: typeof LocaleCoursesIndexRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale_/helpdesk_/connect': {
      id: '/$locale_/helpdesk_/connect';
      path: '/$locale/helpdesk/connect';
      fullPath: '/$locale/helpdesk/connect';
      preLoaderRoute: typeof LocaleHelpdeskConnectRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$locale/courses/$courseId': {
      id: '/$locale/courses/$courseId';
      path: '/courses/$courseId';
      fullPath: '/$locale/courses/$courseId';
      preLoaderRoute: typeof LocaleCoursesCourseIdRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/_authenticated/translations': {
      id: '/$locale/_authenticated/translations';
      path: '/translations';
      fullPath: '/$locale/translations';
      preLoaderRoute: typeof LocaleAuthenticatedTranslationsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/team-dashboard': {
      id: '/$locale/_authenticated/team-dashboard';
      path: '/team-dashboard';
      fullPath: '/$locale/team-dashboard';
      preLoaderRoute: typeof LocaleAuthenticatedTeamDashboardRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/payments': {
      id: '/$locale/_authenticated/payments';
      path: '/payments';
      fullPath: '/$locale/payments';
      preLoaderRoute: typeof LocaleAuthenticatedPaymentsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/dashboard': {
      id: '/$locale/_authenticated/dashboard';
      path: '/dashboard';
      fullPath: '/$locale/dashboard';
      preLoaderRoute: typeof LocaleAuthenticatedDashboardRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics-gear': {
      id: '/$locale/_authenticated/analytics-gear';
      path: '/analytics-gear';
      fullPath: '/$locale/analytics-gear';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsGearRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/account': {
      id: '/$locale/_authenticated/account';
      path: '/account';
      fullPath: '/$locale/account';
      preLoaderRoute: typeof LocaleAuthenticatedAccountRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/warehouse': {
      id: '/$locale/_authenticated/warehouse';
      path: '/warehouse';
      fullPath: '/$locale/warehouse';
      preLoaderRoute: typeof LocaleAuthenticatedWarehouseRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/sync': {
      id: '/$locale/_authenticated/sync';
      path: '/sync';
      fullPath: '/$locale/sync';
      preLoaderRoute: typeof LocaleAuthenticatedSyncRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/student': {
      id: '/$locale/_authenticated/student';
      path: '/student';
      fullPath: '/$locale/student';
      preLoaderRoute: typeof LocaleAuthenticatedStudentRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/shopify': {
      id: '/$locale/_authenticated/shopify';
      path: '/shopify';
      fullPath: '/$locale/shopify';
      preLoaderRoute: typeof LocaleAuthenticatedShopifyRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/instructor': {
      id: '/$locale/_authenticated/instructor';
      path: '/instructor';
      fullPath: '/$locale/instructor';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/gear-erp': {
      id: '/$locale/_authenticated/gear-erp';
      path: '/gear-erp';
      fullPath: '/$locale/gear-erp';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/erp-sync': {
      id: '/$locale/_authenticated/erp-sync';
      path: '/erp-sync';
      fullPath: '/$locale/erp-sync';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics-move': {
      id: '/$locale/_authenticated/analytics-move';
      path: '/analytics-move';
      fullPath: '/$locale/analytics-move';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics': {
      id: '/$locale/_authenticated/analytics';
      path: '/analytics';
      fullPath: '/$locale/analytics';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/admin': {
      id: '/$locale/_authenticated/admin';
      path: '/admin';
      fullPath: '/$locale/admin';
      preLoaderRoute: typeof LocaleAuthenticatedAdminRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/warehouse/': {
      id: '/$locale/_authenticated/warehouse/';
      path: '/';
      fullPath: '/$locale/warehouse/';
      preLoaderRoute: typeof LocaleAuthenticatedWarehouseIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedWarehouseRouteRoute;
    };
    '/$locale/_authenticated/sync/': {
      id: '/$locale/_authenticated/sync/';
      path: '/';
      fullPath: '/$locale/sync/';
      preLoaderRoute: typeof LocaleAuthenticatedSyncIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/student/': {
      id: '/$locale/_authenticated/student/';
      path: '/';
      fullPath: '/$locale/student/';
      preLoaderRoute: typeof LocaleAuthenticatedStudentIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/shopify/': {
      id: '/$locale/_authenticated/shopify/';
      path: '/';
      fullPath: '/$locale/shopify/';
      preLoaderRoute: typeof LocaleAuthenticatedShopifyIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedShopifyRouteRoute;
    };
    '/$locale/_authenticated/instructor/': {
      id: '/$locale/_authenticated/instructor/';
      path: '/';
      fullPath: '/$locale/instructor/';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedInstructorRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/': {
      id: '/$locale/_authenticated/gear-erp/';
      path: '/';
      fullPath: '/$locale/gear-erp/';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/': {
      id: '/$locale/_authenticated/erp-sync/';
      path: '/';
      fullPath: '/$locale/erp-sync/';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/crm/': {
      id: '/$locale/_authenticated/crm/';
      path: '/crm';
      fullPath: '/$locale/crm';
      preLoaderRoute: typeof LocaleAuthenticatedCrmIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics/': {
      id: '/$locale/_authenticated/analytics/';
      path: '/';
      fullPath: '/$locale/analytics/';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/': {
      id: '/$locale/_authenticated/analytics-move/';
      path: '/';
      fullPath: '/$locale/analytics-move/';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/admin/': {
      id: '/$locale/_authenticated/admin/';
      path: '/';
      fullPath: '/$locale/admin/';
      preLoaderRoute: typeof LocaleAuthenticatedAdminIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminRouteRoute;
    };
    '/$locale/_authenticated/warehouse/reports': {
      id: '/$locale/_authenticated/warehouse/reports';
      path: '/reports';
      fullPath: '/$locale/warehouse/reports';
      preLoaderRoute: typeof LocaleAuthenticatedWarehouseReportsLazyRouteImport;
      parentRoute: typeof LocaleAuthenticatedWarehouseRouteRoute;
    };
    '/$locale/recovery/password-reset/$recoveryRequestId': {
      id: '/$locale/recovery/password-reset/$recoveryRequestId';
      path: '/recovery/password-reset/$recoveryRequestId';
      fullPath: '/$locale/recovery/password-reset/$recoveryRequestId';
      preLoaderRoute: typeof LocaleRecoveryPasswordResetRecoveryRequestIdRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/recovery/login-link/$recoveryRequestId': {
      id: '/$locale/recovery/login-link/$recoveryRequestId';
      path: '/recovery/login-link/$recoveryRequestId';
      fullPath: '/$locale/recovery/login-link/$recoveryRequestId';
      preLoaderRoute: typeof LocaleRecoveryLoginLinkRecoveryRequestIdRouteImport;
      parentRoute: typeof LocaleRoute;
    };
    '/$locale/_authenticated/warehouse/warehouses': {
      id: '/$locale/_authenticated/warehouse/warehouses';
      path: '/warehouses';
      fullPath: '/$locale/warehouse/warehouses';
      preLoaderRoute: typeof LocaleAuthenticatedWarehouseWarehousesRouteImport;
      parentRoute: typeof LocaleAuthenticatedWarehouseRouteRoute;
    };
    '/$locale/_authenticated/warehouse/inventory': {
      id: '/$locale/_authenticated/warehouse/inventory';
      path: '/inventory';
      fullPath: '/$locale/warehouse/inventory';
      preLoaderRoute: typeof LocaleAuthenticatedWarehouseInventoryRouteImport;
      parentRoute: typeof LocaleAuthenticatedWarehouseRouteRoute;
    };
    '/$locale/_authenticated/sync/sweep-runs': {
      id: '/$locale/_authenticated/sync/sweep-runs';
      path: '/sweep-runs';
      fullPath: '/$locale/sync/sweep-runs';
      preLoaderRoute: typeof LocaleAuthenticatedSyncSweepRunsRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/sync/relation-queue': {
      id: '/$locale/_authenticated/sync/relation-queue';
      path: '/relation-queue';
      fullPath: '/$locale/sync/relation-queue';
      preLoaderRoute: typeof LocaleAuthenticatedSyncRelationQueueRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/sync/option-sets': {
      id: '/$locale/_authenticated/sync/option-sets';
      path: '/option-sets';
      fullPath: '/$locale/sync/option-sets';
      preLoaderRoute: typeof LocaleAuthenticatedSyncOptionSetsRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/sync/jobs': {
      id: '/$locale/_authenticated/sync/jobs';
      path: '/jobs';
      fullPath: '/$locale/sync/jobs';
      preLoaderRoute: typeof LocaleAuthenticatedSyncJobsRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/sync/data-types': {
      id: '/$locale/_authenticated/sync/data-types';
      path: '/data-types';
      fullPath: '/$locale/sync/data-types';
      preLoaderRoute: typeof LocaleAuthenticatedSyncDataTypesRouteImport;
      parentRoute: typeof LocaleAuthenticatedSyncRouteRoute;
    };
    '/$locale/_authenticated/student/progress': {
      id: '/$locale/_authenticated/student/progress';
      path: '/progress';
      fullPath: '/$locale/student/progress';
      preLoaderRoute: typeof LocaleAuthenticatedStudentProgressRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/student/personal-flow': {
      id: '/$locale/_authenticated/student/personal-flow';
      path: '/personal-flow';
      fullPath: '/$locale/student/personal-flow';
      preLoaderRoute: typeof LocaleAuthenticatedStudentPersonalFlowRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/student/my_courses': {
      id: '/$locale/_authenticated/student/my_courses';
      path: '/my_courses';
      fullPath: '/$locale/student/my_courses';
      preLoaderRoute: typeof LocaleAuthenticatedStudentMy_coursesRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/shopify/stock-control': {
      id: '/$locale/_authenticated/shopify/stock-control';
      path: '/stock-control';
      fullPath: '/$locale/shopify/stock-control';
      preLoaderRoute: typeof LocaleAuthenticatedShopifyStockControlRouteImport;
      parentRoute: typeof LocaleAuthenticatedShopifyRouteRoute;
    };
    '/$locale/_authenticated/payments/$paymentId': {
      id: '/$locale/_authenticated/payments/$paymentId';
      path: '/$paymentId';
      fullPath: '/$locale/payments/$paymentId';
      preLoaderRoute: typeof LocaleAuthenticatedPaymentsPaymentIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedPaymentsRoute;
    };
    '/$locale/_authenticated/instructor/students': {
      id: '/$locale/_authenticated/instructor/students';
      path: '/students';
      fullPath: '/$locale/instructor/students';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorStudentsRouteImport;
      parentRoute: typeof LocaleAuthenticatedInstructorRouteRoute;
    };
    '/$locale/_authenticated/instructor/dashboard': {
      id: '/$locale/_authenticated/instructor/dashboard';
      path: '/dashboard';
      fullPath: '/$locale/instructor/dashboard';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorDashboardRouteImport;
      parentRoute: typeof LocaleAuthenticatedInstructorRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/validation': {
      id: '/$locale/_authenticated/gear-erp/validation';
      path: '/validation';
      fullPath: '/$locale/gear-erp/validation';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpValidationRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/registry': {
      id: '/$locale/_authenticated/gear-erp/registry';
      path: '/registry';
      fullPath: '/$locale/gear-erp/registry';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpRegistryRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/readiness': {
      id: '/$locale/_authenticated/gear-erp/readiness';
      path: '/readiness';
      fullPath: '/$locale/gear-erp/readiness';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpReadinessRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/products': {
      id: '/$locale/_authenticated/gear-erp/products';
      path: '/products';
      fullPath: '/$locale/gear-erp/products';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpProductsRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/migration-batches': {
      id: '/$locale/_authenticated/gear-erp/migration-batches';
      path: '/migration-batches';
      fullPath: '/$locale/gear-erp/migration-batches';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpMigrationBatchesRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/mapping': {
      id: '/$locale/_authenticated/gear-erp/mapping';
      path: '/mapping';
      fullPath: '/$locale/gear-erp/mapping';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpMappingRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/failures': {
      id: '/$locale/_authenticated/gear-erp/failures';
      path: '/failures';
      fullPath: '/$locale/gear-erp/failures';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpFailuresRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/evidence': {
      id: '/$locale/_authenticated/gear-erp/evidence';
      path: '/evidence';
      fullPath: '/$locale/gear-erp/evidence';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpEvidenceRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/gear-erp/data-quality': {
      id: '/$locale/_authenticated/gear-erp/data-quality';
      path: '/data-quality';
      fullPath: '/$locale/gear-erp/data-quality';
      preLoaderRoute: typeof LocaleAuthenticatedGearErpDataQualityRouteImport;
      parentRoute: typeof LocaleAuthenticatedGearErpRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/validation': {
      id: '/$locale/_authenticated/erp-sync/validation';
      path: '/validation';
      fullPath: '/$locale/erp-sync/validation';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncValidationRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/registry': {
      id: '/$locale/_authenticated/erp-sync/registry';
      path: '/registry';
      fullPath: '/$locale/erp-sync/registry';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncRegistryRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/readiness': {
      id: '/$locale/_authenticated/erp-sync/readiness';
      path: '/readiness';
      fullPath: '/$locale/erp-sync/readiness';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncReadinessRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/migration-batches': {
      id: '/$locale/_authenticated/erp-sync/migration-batches';
      path: '/migration-batches';
      fullPath: '/$locale/erp-sync/migration-batches';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncMigrationBatchesRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/mapping': {
      id: '/$locale/_authenticated/erp-sync/mapping';
      path: '/mapping';
      fullPath: '/$locale/erp-sync/mapping';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncMappingRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/failures': {
      id: '/$locale/_authenticated/erp-sync/failures';
      path: '/failures';
      fullPath: '/$locale/erp-sync/failures';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncFailuresRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/evidence': {
      id: '/$locale/_authenticated/erp-sync/evidence';
      path: '/evidence';
      fullPath: '/$locale/erp-sync/evidence';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncEvidenceRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/erp-sync/data-quality': {
      id: '/$locale/_authenticated/erp-sync/data-quality';
      path: '/data-quality';
      fullPath: '/$locale/erp-sync/data-quality';
      preLoaderRoute: typeof LocaleAuthenticatedErpSyncDataQualityRouteImport;
      parentRoute: typeof LocaleAuthenticatedErpSyncRouteRoute;
    };
    '/$locale/_authenticated/crm/search': {
      id: '/$locale/_authenticated/crm/search';
      path: '/crm/search';
      fullPath: '/$locale/crm/search';
      preLoaderRoute: typeof LocaleAuthenticatedCrmSearchRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/analytics': {
      id: '/$locale/_authenticated/crm/analytics';
      path: '/crm/analytics';
      fullPath: '/$locale/crm/analytics';
      preLoaderRoute: typeof LocaleAuthenticatedCrmAnalyticsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics/overview': {
      id: '/$locale/_authenticated/analytics/overview';
      path: '/overview';
      fullPath: '/$locale/analytics/overview';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsOverviewRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsRouteRoute;
    };
    '/$locale/_authenticated/analytics/gear-express': {
      id: '/$locale/_authenticated/analytics/gear-express';
      path: '/gear-express';
      fullPath: '/$locale/analytics/gear-express';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsGearExpressRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/translations': {
      id: '/$locale/_authenticated/analytics-move/translations';
      path: '/translations';
      fullPath: '/$locale/analytics-move/translations';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveTranslationsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/training-programs': {
      id: '/$locale/_authenticated/analytics-move/training-programs';
      path: '/training-programs';
      fullPath: '/$locale/analytics-move/training-programs';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveTrainingProgramsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/revenue': {
      id: '/$locale/_authenticated/analytics-move/revenue';
      path: '/revenue';
      fullPath: '/$locale/analytics-move/revenue';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveRevenueRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/registrations': {
      id: '/$locale/_authenticated/analytics-move/registrations';
      path: '/registrations';
      fullPath: '/$locale/analytics-move/registrations';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveRegistrationsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/registration-top30': {
      id: '/$locale/_authenticated/analytics-move/registration-top30';
      path: '/registration-top30';
      fullPath: '/$locale/analytics-move/registration-top30';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveRegistrationTop30RouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/overview': {
      id: '/$locale/_authenticated/analytics-move/overview';
      path: '/overview';
      fullPath: '/$locale/analytics-move/overview';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveOverviewRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/membership': {
      id: '/$locale/_authenticated/analytics-move/membership';
      path: '/membership';
      fullPath: '/$locale/analytics-move/membership';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveMembershipRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/members': {
      id: '/$locale/_authenticated/analytics-move/members';
      path: '/members';
      fullPath: '/$locale/analytics-move/members';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveMembersRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/maps': {
      id: '/$locale/_authenticated/analytics-move/maps';
      path: '/maps';
      fullPath: '/$locale/analytics-move/maps';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveMapsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/main-location': {
      id: '/$locale/_authenticated/analytics-move/main-location';
      path: '/main-location';
      fullPath: '/$locale/analytics-move/main-location';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveMainLocationRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/education': {
      id: '/$locale/_authenticated/analytics-move/education';
      path: '/education';
      fullPath: '/$locale/analytics-move/education';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveEducationRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/courses': {
      id: '/$locale/_authenticated/analytics-move/courses';
      path: '/courses';
      fullPath: '/$locale/analytics-move/courses';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveCoursesRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/certifications': {
      id: '/$locale/_authenticated/analytics-move/certifications';
      path: '/certifications';
      fullPath: '/$locale/analytics-move/certifications';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveCertificationsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/admin/overview': {
      id: '/$locale/_authenticated/admin/overview';
      path: '/overview';
      fullPath: '/$locale/admin/overview';
      preLoaderRoute: typeof LocaleAuthenticatedAdminOverviewRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminRouteRoute;
    };
    '/$locale/_authenticated/admin/database': {
      id: '/$locale/_authenticated/admin/database';
      path: '/database';
      fullPath: '/$locale/admin/database';
      preLoaderRoute: typeof LocaleAuthenticatedAdminDatabaseRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminRouteRoute;
    };
    '/$locale/_authenticated/analytics/weekly': {
      id: '/$locale/_authenticated/analytics/weekly';
      path: '/weekly';
      fullPath: '/$locale/analytics/weekly';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsWeeklyRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/weekly': {
      id: '/$locale/_authenticated/analytics-move/weekly';
      path: '/weekly';
      fullPath: '/$locale/analytics-move/weekly';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRoute;
    };
    '/$locale/_authenticated/admin/settings': {
      id: '/$locale/_authenticated/admin/settings';
      path: '/settings';
      fullPath: '/$locale/admin/settings';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminRouteRoute;
    };
    '/$locale/_authenticated/instructor/courses/': {
      id: '/$locale/_authenticated/instructor/courses/';
      path: '/courses';
      fullPath: '/$locale/instructor/courses';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorCoursesIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedInstructorRouteRoute;
    };
    '/$locale/_authenticated/crm/memberships/': {
      id: '/$locale/_authenticated/crm/memberships/';
      path: '/crm/memberships';
      fullPath: '/$locale/crm/memberships';
      preLoaderRoute: typeof LocaleAuthenticatedCrmMembershipsIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/': {
      id: '/$locale/_authenticated/crm/helpdesk/';
      path: '/crm/helpdesk';
      fullPath: '/$locale/crm/helpdesk';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics/weekly/': {
      id: '/$locale/_authenticated/analytics/weekly/';
      path: '/';
      fullPath: '/$locale/analytics/weekly/';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsWeeklyIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsWeeklyRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/weekly/': {
      id: '/$locale/_authenticated/analytics-move/weekly/';
      path: '/';
      fullPath: '/$locale/analytics-move/weekly/';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/': {
      id: '/$locale/_authenticated/admin/settings/';
      path: '/';
      fullPath: '/$locale/admin/settings/';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/student/documents/$documentId': {
      id: '/$locale/_authenticated/student/documents/$documentId';
      path: '/documents/$documentId';
      fullPath: '/$locale/student/documents/$documentId';
      preLoaderRoute: typeof LocaleAuthenticatedStudentDocumentsDocumentIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/student/courses/$courseId': {
      id: '/$locale/_authenticated/student/courses/$courseId';
      path: '/courses/$courseId';
      fullPath: '/$locale/student/courses/$courseId';
      preLoaderRoute: typeof LocaleAuthenticatedStudentCoursesCourseIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/instructor/courses/$courseId': {
      id: '/$locale/_authenticated/instructor/courses/$courseId';
      path: '/courses/$courseId';
      fullPath: '/$locale/instructor/courses/$courseId';
      preLoaderRoute: typeof LocaleAuthenticatedInstructorCoursesCourseIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedInstructorRouteRoute;
    };
    '/$locale/_authenticated/crm/memberships/$membershipId': {
      id: '/$locale/_authenticated/crm/memberships/$membershipId';
      path: '/crm/memberships/$membershipId';
      fullPath: '/$locale/crm/memberships/$membershipId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmMembershipsMembershipIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/settings': {
      id: '/$locale/_authenticated/crm/helpdesk/settings';
      path: '/crm/helpdesk/settings';
      fullPath: '/$locale/crm/helpdesk/settings';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskSettingsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/prompts': {
      id: '/$locale/_authenticated/crm/helpdesk/prompts';
      path: '/crm/helpdesk/prompts';
      fullPath: '/$locale/crm/helpdesk/prompts';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/instructions': {
      id: '/$locale/_authenticated/crm/helpdesk/instructions';
      path: '/crm/helpdesk/instructions';
      fullPath: '/$locale/crm/helpdesk/instructions';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/articles': {
      id: '/$locale/_authenticated/crm/helpdesk/articles';
      path: '/crm/helpdesk/articles';
      fullPath: '/$locale/crm/helpdesk/articles';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/$taskUuid': {
      id: '/$locale/_authenticated/crm/helpdesk/$taskUuid';
      path: '/crm/helpdesk/$taskUuid';
      fullPath: '/$locale/crm/helpdesk/$taskUuid';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskTaskUuidRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/courses/$courseId': {
      id: '/$locale/_authenticated/crm/courses/$courseId';
      path: '/crm/courses/$courseId';
      fullPath: '/$locale/crm/courses/$courseId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmCoursesCourseIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/analytics/weekly/$weekId': {
      id: '/$locale/_authenticated/analytics/weekly/$weekId';
      path: '/$weekId';
      fullPath: '/$locale/analytics/weekly/$weekId';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsWeeklyWeekIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsWeeklyRouteRoute;
    };
    '/$locale/_authenticated/analytics-move/weekly/$weekId': {
      id: '/$locale/_authenticated/analytics-move/weekly/$weekId';
      path: '/$weekId';
      fullPath: '/$locale/analytics-move/weekly/$weekId';
      preLoaderRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/helpdesk': {
      id: '/$locale/_authenticated/admin/settings/helpdesk';
      path: '/helpdesk';
      fullPath: '/$locale/admin/settings/helpdesk';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsHelpdeskRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId';
      path: '/crm/user-profiles/$userProfileId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/customers/$customerId': {
      id: '/$locale/_authenticated/crm/customers/$customerId';
      path: '/crm/customers/$customerId';
      fullPath: '/$locale/crm/customers/$customerId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteImport;
      parentRoute: typeof LocaleAuthenticatedRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/';
      path: '/';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/prompts/': {
      id: '/$locale/_authenticated/crm/helpdesk/prompts/';
      path: '/';
      fullPath: '/$locale/crm/helpdesk/prompts/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/instructions/': {
      id: '/$locale/_authenticated/crm/helpdesk/instructions/';
      path: '/';
      fullPath: '/$locale/crm/helpdesk/instructions/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/articles/': {
      id: '/$locale/_authenticated/crm/helpdesk/articles/';
      path: '/';
      fullPath: '/$locale/crm/helpdesk/articles/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesRoute;
    };
    '/$locale/_authenticated/student/onboarding/activities/$activityKey': {
      id: '/$locale/_authenticated/student/onboarding/activities/$activityKey';
      path: '/onboarding/activities/$activityKey';
      fullPath: '/$locale/student/onboarding/activities/$activityKey';
      preLoaderRoute: typeof LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/student/education/modules/$moduleId': {
      id: '/$locale/_authenticated/student/education/modules/$moduleId';
      path: '/education/modules/$moduleId';
      fullPath: '/$locale/student/education/modules/$moduleId';
      preLoaderRoute: typeof LocaleAuthenticatedStudentEducationModulesModuleIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/training': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/training';
      path: '/training';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/training';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/sync': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/sync';
      path: '/sync';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/sync';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/payments': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/payments';
      path: '/payments';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/payments';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/membership': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/membership';
      path: '/membership';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/membership';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning';
      path: '/learning';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/helpdesk': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/helpdesk';
      path: '/helpdesk';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/helpdesk';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents';
      path: '/documents';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/documents';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey';
      path: '/$areaKey';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/$areaKey';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/prompts/new': {
      id: '/$locale/_authenticated/crm/helpdesk/prompts/new';
      path: '/new';
      fullPath: '/$locale/crm/helpdesk/prompts/new';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsNewRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/prompts/$promptId': {
      id: '/$locale/_authenticated/crm/helpdesk/prompts/$promptId';
      path: '/$promptId';
      fullPath: '/$locale/crm/helpdesk/prompts/$promptId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/instructions/new': {
      id: '/$locale/_authenticated/crm/helpdesk/instructions/new';
      path: '/new';
      fullPath: '/$locale/crm/helpdesk/instructions/new';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsNewRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/instructions/$instructionId': {
      id: '/$locale/_authenticated/crm/helpdesk/instructions/$instructionId';
      path: '/$instructionId';
      fullPath: '/$locale/crm/helpdesk/instructions/$instructionId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/articles/new': {
      id: '/$locale/_authenticated/crm/helpdesk/articles/new';
      path: '/new';
      fullPath: '/$locale/crm/helpdesk/articles/new';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesNewRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesRoute;
    };
    '/$locale/_authenticated/crm/helpdesk/articles/$articleId': {
      id: '/$locale/_authenticated/crm/helpdesk/articles/$articleId';
      path: '/$articleId';
      fullPath: '/$locale/crm/helpdesk/articles/$articleId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesRoute;
    };
    '/$locale/_authenticated/crm/customers/$customerId/$': {
      id: '/$locale/_authenticated/crm/customers/$customerId/$';
      path: '/$';
      fullPath: '/$locale/crm/customers/$customerId/$';
      preLoaderRoute: typeof LocaleAuthenticatedCrmCustomersCustomerIdSplatRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/operations/$sectionId': {
      id: '/$locale/_authenticated/admin/settings/operations/$sectionId';
      path: '/operations/$sectionId';
      fullPath: '/$locale/admin/settings/operations/$sectionId';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsOperationsSectionIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/business/roles': {
      id: '/$locale/_authenticated/admin/settings/business/roles';
      path: '/business/roles';
      fullPath: '/$locale/admin/settings/business/roles';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessRolesRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/business/locations': {
      id: '/$locale/_authenticated/admin/settings/business/locations';
      path: '/business/locations';
      fullPath: '/$locale/admin/settings/business/locations';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessLocationsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/business/$sectionId': {
      id: '/$locale/_authenticated/admin/settings/business/$sectionId';
      path: '/business/$sectionId';
      fullPath: '/$locale/admin/settings/business/$sectionId';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessSectionIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/';
      path: '/';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/training/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/';
      path: '/';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
    '/$locale/_authenticated/student/registrations/$registrationId/activities/$activityKey': {
      id: '/$locale/_authenticated/student/registrations/$registrationId/activities/$activityKey';
      path: '/registrations/$registrationId/activities/$activityKey';
      fullPath: '/$locale/student/registrations/$registrationId/activities/$activityKey';
      preLoaderRoute: typeof LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRouteImport;
      parentRoute: typeof LocaleAuthenticatedStudentRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/$programLogId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/training/$programLogId';
      path: '/$programLogId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/training/$programLogId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new';
      path: '/new';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/documents/new';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/$documentId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/$documentId';
      path: '/$documentId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/documents/$documentId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute;
    };
    '/$locale/_authenticated/admin/settings/operations/integrations/revenuecat': {
      id: '/$locale/_authenticated/admin/settings/operations/integrations/revenuecat';
      path: '/operations/integrations/revenuecat';
      fullPath: '/$locale/admin/settings/operations/integrations/revenuecat';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/operations/integrations/gmail': {
      id: '/$locale/_authenticated/admin/settings/operations/integrations/gmail';
      path: '/operations/integrations/gmail';
      fullPath: '/$locale/admin/settings/operations/integrations/gmail';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/business/roles/audit': {
      id: '/$locale/_authenticated/admin/settings/business/roles/audit';
      path: '/audit';
      fullPath: '/$locale/admin/settings/business/roles/audit';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessRolesAuditRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsBusinessRolesRoute;
    };
    '/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes': {
      id: '/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes';
      path: '/business/communications-promotions/promocodes';
      fullPath: '/$locale/admin/settings/business/communications-promotions/promocodes';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups': {
      id: '/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups';
      path: '/business/communications-promotions/ad-popups';
      fullPath: '/$locale/admin/settings/business/communications-promotions/ad-popups';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/': {
      id: '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/';
      path: '/operations/integrations/klaviyo';
      fullPath: '/$locale/admin/settings/operations/integrations/klaviyo';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId';
      path: '/registrations/$registrationId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId';
      path: '/education-module-logs/$educationModuleLogId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId';
      path: '/courses/$courseId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/courses/$courseId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/certifications/$certificationId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/certifications/$certificationId';
      path: '/certifications/$certificationId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/certifications/$certificationId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
    '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers': {
      id: '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/event-triggers';
      path: '/operations/integrations/klaviyo/event-triggers';
      fullPath: '/$locale/admin/settings/operations/integrations/klaviyo/event-triggers';
      preLoaderRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRouteImport;
      parentRoute: typeof LocaleAuthenticatedAdminSettingsRouteRoute;
    };
    '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId_/completion-form/$documentId': {
      id: '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/registrations/$registrationId_/completion-form/$documentId';
      path: '/registrations/$registrationId/completion-form/$documentId';
      fullPath: '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId/completion-form/$documentId';
      preLoaderRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRouteImport;
      parentRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute;
    };
  }
}

interface LocaleAuthenticatedAdminSettingsBusinessRolesRouteChildren {
  LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute: typeof LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute;
}

const LocaleAuthenticatedAdminSettingsBusinessRolesRouteChildren: LocaleAuthenticatedAdminSettingsBusinessRolesRouteChildren =
  {
    LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute:
      LocaleAuthenticatedAdminSettingsBusinessRolesAuditRoute,
  };

const LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren =
  LocaleAuthenticatedAdminSettingsBusinessRolesRoute._addFileChildren(
    LocaleAuthenticatedAdminSettingsBusinessRolesRouteChildren,
  );

interface LocaleAuthenticatedAdminSettingsRouteRouteChildren {
  LocaleAuthenticatedAdminSettingsHelpdeskRoute: typeof LocaleAuthenticatedAdminSettingsHelpdeskRoute;
  LocaleAuthenticatedAdminSettingsIndexRoute: typeof LocaleAuthenticatedAdminSettingsIndexRoute;
  LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute: typeof LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute;
  LocaleAuthenticatedAdminSettingsBusinessLocationsRoute: typeof LocaleAuthenticatedAdminSettingsBusinessLocationsRoute;
  LocaleAuthenticatedAdminSettingsBusinessRolesRoute: typeof LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren;
  LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute: typeof LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute;
  LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute: typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute;
  LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute: typeof LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute;
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute;
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute;
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute;
  LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute: typeof LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute;
}

const LocaleAuthenticatedAdminSettingsRouteRouteChildren: LocaleAuthenticatedAdminSettingsRouteRouteChildren =
  {
    LocaleAuthenticatedAdminSettingsHelpdeskRoute:
      LocaleAuthenticatedAdminSettingsHelpdeskRoute,
    LocaleAuthenticatedAdminSettingsIndexRoute:
      LocaleAuthenticatedAdminSettingsIndexRoute,
    LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute:
      LocaleAuthenticatedAdminSettingsBusinessSectionIdRoute,
    LocaleAuthenticatedAdminSettingsBusinessLocationsRoute:
      LocaleAuthenticatedAdminSettingsBusinessLocationsRoute,
    LocaleAuthenticatedAdminSettingsBusinessRolesRoute:
      LocaleAuthenticatedAdminSettingsBusinessRolesRouteWithChildren,
    LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute:
      LocaleAuthenticatedAdminSettingsOperationsSectionIdRoute,
    LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute:
      LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsAdPopupsRoute,
    LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute:
      LocaleAuthenticatedAdminSettingsBusinessCommunicationsPromotionsPromocodesRoute,
    LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute:
      LocaleAuthenticatedAdminSettingsOperationsIntegrationsGmailRoute,
    LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute:
      LocaleAuthenticatedAdminSettingsOperationsIntegrationsRevenuecatRoute,
    LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute:
      LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoEventTriggersRoute,
    LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute:
      LocaleAuthenticatedAdminSettingsOperationsIntegrationsKlaviyoIndexRoute,
  };

const LocaleAuthenticatedAdminSettingsRouteRouteWithChildren =
  LocaleAuthenticatedAdminSettingsRouteRoute._addFileChildren(
    LocaleAuthenticatedAdminSettingsRouteRouteChildren,
  );

interface LocaleAuthenticatedAdminRouteRouteChildren {
  LocaleAuthenticatedAdminSettingsRouteRoute: typeof LocaleAuthenticatedAdminSettingsRouteRouteWithChildren;
  LocaleAuthenticatedAdminDatabaseRoute: typeof LocaleAuthenticatedAdminDatabaseRoute;
  LocaleAuthenticatedAdminOverviewRoute: typeof LocaleAuthenticatedAdminOverviewRoute;
  LocaleAuthenticatedAdminIndexRoute: typeof LocaleAuthenticatedAdminIndexRoute;
}

const LocaleAuthenticatedAdminRouteRouteChildren: LocaleAuthenticatedAdminRouteRouteChildren =
  {
    LocaleAuthenticatedAdminSettingsRouteRoute:
      LocaleAuthenticatedAdminSettingsRouteRouteWithChildren,
    LocaleAuthenticatedAdminDatabaseRoute:
      LocaleAuthenticatedAdminDatabaseRoute,
    LocaleAuthenticatedAdminOverviewRoute:
      LocaleAuthenticatedAdminOverviewRoute,
    LocaleAuthenticatedAdminIndexRoute: LocaleAuthenticatedAdminIndexRoute,
  };

const LocaleAuthenticatedAdminRouteRouteWithChildren =
  LocaleAuthenticatedAdminRouteRoute._addFileChildren(
    LocaleAuthenticatedAdminRouteRouteChildren,
  );

interface LocaleAuthenticatedAnalyticsWeeklyRouteRouteChildren {
  LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute: typeof LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute;
  LocaleAuthenticatedAnalyticsWeeklyIndexRoute: typeof LocaleAuthenticatedAnalyticsWeeklyIndexRoute;
}

const LocaleAuthenticatedAnalyticsWeeklyRouteRouteChildren: LocaleAuthenticatedAnalyticsWeeklyRouteRouteChildren =
  {
    LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute:
      LocaleAuthenticatedAnalyticsWeeklyWeekIdRoute,
    LocaleAuthenticatedAnalyticsWeeklyIndexRoute:
      LocaleAuthenticatedAnalyticsWeeklyIndexRoute,
  };

const LocaleAuthenticatedAnalyticsWeeklyRouteRouteWithChildren =
  LocaleAuthenticatedAnalyticsWeeklyRouteRoute._addFileChildren(
    LocaleAuthenticatedAnalyticsWeeklyRouteRouteChildren,
  );

interface LocaleAuthenticatedAnalyticsRouteRouteChildren {
  LocaleAuthenticatedAnalyticsWeeklyRouteRoute: typeof LocaleAuthenticatedAnalyticsWeeklyRouteRouteWithChildren;
  LocaleAuthenticatedAnalyticsGearExpressRoute: typeof LocaleAuthenticatedAnalyticsGearExpressRoute;
  LocaleAuthenticatedAnalyticsOverviewRoute: typeof LocaleAuthenticatedAnalyticsOverviewRoute;
  LocaleAuthenticatedAnalyticsIndexRoute: typeof LocaleAuthenticatedAnalyticsIndexRoute;
}

const LocaleAuthenticatedAnalyticsRouteRouteChildren: LocaleAuthenticatedAnalyticsRouteRouteChildren =
  {
    LocaleAuthenticatedAnalyticsWeeklyRouteRoute:
      LocaleAuthenticatedAnalyticsWeeklyRouteRouteWithChildren,
    LocaleAuthenticatedAnalyticsGearExpressRoute:
      LocaleAuthenticatedAnalyticsGearExpressRoute,
    LocaleAuthenticatedAnalyticsOverviewRoute:
      LocaleAuthenticatedAnalyticsOverviewRoute,
    LocaleAuthenticatedAnalyticsIndexRoute:
      LocaleAuthenticatedAnalyticsIndexRoute,
  };

const LocaleAuthenticatedAnalyticsRouteRouteWithChildren =
  LocaleAuthenticatedAnalyticsRouteRoute._addFileChildren(
    LocaleAuthenticatedAnalyticsRouteRouteChildren,
  );

interface LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteChildren {
  LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute;
  LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute;
}

const LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteChildren: LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteChildren =
  {
    LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute:
      LocaleAuthenticatedAnalyticsMoveWeeklyWeekIdRoute,
    LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute:
      LocaleAuthenticatedAnalyticsMoveWeeklyIndexRoute,
  };

const LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteWithChildren =
  LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute._addFileChildren(
    LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteChildren,
  );

interface LocaleAuthenticatedAnalyticsMoveRouteRouteChildren {
  LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute: typeof LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteWithChildren;
  LocaleAuthenticatedAnalyticsMoveCertificationsRoute: typeof LocaleAuthenticatedAnalyticsMoveCertificationsRoute;
  LocaleAuthenticatedAnalyticsMoveCoursesRoute: typeof LocaleAuthenticatedAnalyticsMoveCoursesRoute;
  LocaleAuthenticatedAnalyticsMoveEducationRoute: typeof LocaleAuthenticatedAnalyticsMoveEducationRoute;
  LocaleAuthenticatedAnalyticsMoveMainLocationRoute: typeof LocaleAuthenticatedAnalyticsMoveMainLocationRoute;
  LocaleAuthenticatedAnalyticsMoveMapsRoute: typeof LocaleAuthenticatedAnalyticsMoveMapsRoute;
  LocaleAuthenticatedAnalyticsMoveMembersRoute: typeof LocaleAuthenticatedAnalyticsMoveMembersRoute;
  LocaleAuthenticatedAnalyticsMoveMembershipRoute: typeof LocaleAuthenticatedAnalyticsMoveMembershipRoute;
  LocaleAuthenticatedAnalyticsMoveOverviewRoute: typeof LocaleAuthenticatedAnalyticsMoveOverviewRoute;
  LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route: typeof LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route;
  LocaleAuthenticatedAnalyticsMoveRegistrationsRoute: typeof LocaleAuthenticatedAnalyticsMoveRegistrationsRoute;
  LocaleAuthenticatedAnalyticsMoveRevenueRoute: typeof LocaleAuthenticatedAnalyticsMoveRevenueRoute;
  LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute: typeof LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute;
  LocaleAuthenticatedAnalyticsMoveTranslationsRoute: typeof LocaleAuthenticatedAnalyticsMoveTranslationsRoute;
  LocaleAuthenticatedAnalyticsMoveIndexRoute: typeof LocaleAuthenticatedAnalyticsMoveIndexRoute;
}

const LocaleAuthenticatedAnalyticsMoveRouteRouteChildren: LocaleAuthenticatedAnalyticsMoveRouteRouteChildren =
  {
    LocaleAuthenticatedAnalyticsMoveWeeklyRouteRoute:
      LocaleAuthenticatedAnalyticsMoveWeeklyRouteRouteWithChildren,
    LocaleAuthenticatedAnalyticsMoveCertificationsRoute:
      LocaleAuthenticatedAnalyticsMoveCertificationsRoute,
    LocaleAuthenticatedAnalyticsMoveCoursesRoute:
      LocaleAuthenticatedAnalyticsMoveCoursesRoute,
    LocaleAuthenticatedAnalyticsMoveEducationRoute:
      LocaleAuthenticatedAnalyticsMoveEducationRoute,
    LocaleAuthenticatedAnalyticsMoveMainLocationRoute:
      LocaleAuthenticatedAnalyticsMoveMainLocationRoute,
    LocaleAuthenticatedAnalyticsMoveMapsRoute:
      LocaleAuthenticatedAnalyticsMoveMapsRoute,
    LocaleAuthenticatedAnalyticsMoveMembersRoute:
      LocaleAuthenticatedAnalyticsMoveMembersRoute,
    LocaleAuthenticatedAnalyticsMoveMembershipRoute:
      LocaleAuthenticatedAnalyticsMoveMembershipRoute,
    LocaleAuthenticatedAnalyticsMoveOverviewRoute:
      LocaleAuthenticatedAnalyticsMoveOverviewRoute,
    LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route:
      LocaleAuthenticatedAnalyticsMoveRegistrationTop30Route,
    LocaleAuthenticatedAnalyticsMoveRegistrationsRoute:
      LocaleAuthenticatedAnalyticsMoveRegistrationsRoute,
    LocaleAuthenticatedAnalyticsMoveRevenueRoute:
      LocaleAuthenticatedAnalyticsMoveRevenueRoute,
    LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute:
      LocaleAuthenticatedAnalyticsMoveTrainingProgramsRoute,
    LocaleAuthenticatedAnalyticsMoveTranslationsRoute:
      LocaleAuthenticatedAnalyticsMoveTranslationsRoute,
    LocaleAuthenticatedAnalyticsMoveIndexRoute:
      LocaleAuthenticatedAnalyticsMoveIndexRoute,
  };

const LocaleAuthenticatedAnalyticsMoveRouteRouteWithChildren =
  LocaleAuthenticatedAnalyticsMoveRouteRoute._addFileChildren(
    LocaleAuthenticatedAnalyticsMoveRouteRouteChildren,
  );

interface LocaleAuthenticatedErpSyncRouteRouteChildren {
  LocaleAuthenticatedErpSyncDataQualityRoute: typeof LocaleAuthenticatedErpSyncDataQualityRoute;
  LocaleAuthenticatedErpSyncEvidenceRoute: typeof LocaleAuthenticatedErpSyncEvidenceRoute;
  LocaleAuthenticatedErpSyncFailuresRoute: typeof LocaleAuthenticatedErpSyncFailuresRoute;
  LocaleAuthenticatedErpSyncMappingRoute: typeof LocaleAuthenticatedErpSyncMappingRoute;
  LocaleAuthenticatedErpSyncMigrationBatchesRoute: typeof LocaleAuthenticatedErpSyncMigrationBatchesRoute;
  LocaleAuthenticatedErpSyncReadinessRoute: typeof LocaleAuthenticatedErpSyncReadinessRoute;
  LocaleAuthenticatedErpSyncRegistryRoute: typeof LocaleAuthenticatedErpSyncRegistryRoute;
  LocaleAuthenticatedErpSyncValidationRoute: typeof LocaleAuthenticatedErpSyncValidationRoute;
  LocaleAuthenticatedErpSyncIndexRoute: typeof LocaleAuthenticatedErpSyncIndexRoute;
}

const LocaleAuthenticatedErpSyncRouteRouteChildren: LocaleAuthenticatedErpSyncRouteRouteChildren =
  {
    LocaleAuthenticatedErpSyncDataQualityRoute:
      LocaleAuthenticatedErpSyncDataQualityRoute,
    LocaleAuthenticatedErpSyncEvidenceRoute:
      LocaleAuthenticatedErpSyncEvidenceRoute,
    LocaleAuthenticatedErpSyncFailuresRoute:
      LocaleAuthenticatedErpSyncFailuresRoute,
    LocaleAuthenticatedErpSyncMappingRoute:
      LocaleAuthenticatedErpSyncMappingRoute,
    LocaleAuthenticatedErpSyncMigrationBatchesRoute:
      LocaleAuthenticatedErpSyncMigrationBatchesRoute,
    LocaleAuthenticatedErpSyncReadinessRoute:
      LocaleAuthenticatedErpSyncReadinessRoute,
    LocaleAuthenticatedErpSyncRegistryRoute:
      LocaleAuthenticatedErpSyncRegistryRoute,
    LocaleAuthenticatedErpSyncValidationRoute:
      LocaleAuthenticatedErpSyncValidationRoute,
    LocaleAuthenticatedErpSyncIndexRoute: LocaleAuthenticatedErpSyncIndexRoute,
  };

const LocaleAuthenticatedErpSyncRouteRouteWithChildren =
  LocaleAuthenticatedErpSyncRouteRoute._addFileChildren(
    LocaleAuthenticatedErpSyncRouteRouteChildren,
  );

interface LocaleAuthenticatedGearErpRouteRouteChildren {
  LocaleAuthenticatedGearErpDataQualityRoute: typeof LocaleAuthenticatedGearErpDataQualityRoute;
  LocaleAuthenticatedGearErpEvidenceRoute: typeof LocaleAuthenticatedGearErpEvidenceRoute;
  LocaleAuthenticatedGearErpFailuresRoute: typeof LocaleAuthenticatedGearErpFailuresRoute;
  LocaleAuthenticatedGearErpMappingRoute: typeof LocaleAuthenticatedGearErpMappingRoute;
  LocaleAuthenticatedGearErpMigrationBatchesRoute: typeof LocaleAuthenticatedGearErpMigrationBatchesRoute;
  LocaleAuthenticatedGearErpProductsRoute: typeof LocaleAuthenticatedGearErpProductsRoute;
  LocaleAuthenticatedGearErpReadinessRoute: typeof LocaleAuthenticatedGearErpReadinessRoute;
  LocaleAuthenticatedGearErpRegistryRoute: typeof LocaleAuthenticatedGearErpRegistryRoute;
  LocaleAuthenticatedGearErpValidationRoute: typeof LocaleAuthenticatedGearErpValidationRoute;
  LocaleAuthenticatedGearErpIndexRoute: typeof LocaleAuthenticatedGearErpIndexRoute;
}

const LocaleAuthenticatedGearErpRouteRouteChildren: LocaleAuthenticatedGearErpRouteRouteChildren =
  {
    LocaleAuthenticatedGearErpDataQualityRoute:
      LocaleAuthenticatedGearErpDataQualityRoute,
    LocaleAuthenticatedGearErpEvidenceRoute:
      LocaleAuthenticatedGearErpEvidenceRoute,
    LocaleAuthenticatedGearErpFailuresRoute:
      LocaleAuthenticatedGearErpFailuresRoute,
    LocaleAuthenticatedGearErpMappingRoute:
      LocaleAuthenticatedGearErpMappingRoute,
    LocaleAuthenticatedGearErpMigrationBatchesRoute:
      LocaleAuthenticatedGearErpMigrationBatchesRoute,
    LocaleAuthenticatedGearErpProductsRoute:
      LocaleAuthenticatedGearErpProductsRoute,
    LocaleAuthenticatedGearErpReadinessRoute:
      LocaleAuthenticatedGearErpReadinessRoute,
    LocaleAuthenticatedGearErpRegistryRoute:
      LocaleAuthenticatedGearErpRegistryRoute,
    LocaleAuthenticatedGearErpValidationRoute:
      LocaleAuthenticatedGearErpValidationRoute,
    LocaleAuthenticatedGearErpIndexRoute: LocaleAuthenticatedGearErpIndexRoute,
  };

const LocaleAuthenticatedGearErpRouteRouteWithChildren =
  LocaleAuthenticatedGearErpRouteRoute._addFileChildren(
    LocaleAuthenticatedGearErpRouteRouteChildren,
  );

interface LocaleAuthenticatedInstructorRouteRouteChildren {
  LocaleAuthenticatedInstructorDashboardRoute: typeof LocaleAuthenticatedInstructorDashboardRoute;
  LocaleAuthenticatedInstructorStudentsRoute: typeof LocaleAuthenticatedInstructorStudentsRoute;
  LocaleAuthenticatedInstructorIndexRoute: typeof LocaleAuthenticatedInstructorIndexRoute;
  LocaleAuthenticatedInstructorCoursesCourseIdRoute: typeof LocaleAuthenticatedInstructorCoursesCourseIdRoute;
  LocaleAuthenticatedInstructorCoursesIndexRoute: typeof LocaleAuthenticatedInstructorCoursesIndexRoute;
}

const LocaleAuthenticatedInstructorRouteRouteChildren: LocaleAuthenticatedInstructorRouteRouteChildren =
  {
    LocaleAuthenticatedInstructorDashboardRoute:
      LocaleAuthenticatedInstructorDashboardRoute,
    LocaleAuthenticatedInstructorStudentsRoute:
      LocaleAuthenticatedInstructorStudentsRoute,
    LocaleAuthenticatedInstructorIndexRoute:
      LocaleAuthenticatedInstructorIndexRoute,
    LocaleAuthenticatedInstructorCoursesCourseIdRoute:
      LocaleAuthenticatedInstructorCoursesCourseIdRoute,
    LocaleAuthenticatedInstructorCoursesIndexRoute:
      LocaleAuthenticatedInstructorCoursesIndexRoute,
  };

const LocaleAuthenticatedInstructorRouteRouteWithChildren =
  LocaleAuthenticatedInstructorRouteRoute._addFileChildren(
    LocaleAuthenticatedInstructorRouteRouteChildren,
  );

interface LocaleAuthenticatedShopifyRouteRouteChildren {
  LocaleAuthenticatedShopifyStockControlRoute: typeof LocaleAuthenticatedShopifyStockControlRoute;
  LocaleAuthenticatedShopifyIndexRoute: typeof LocaleAuthenticatedShopifyIndexRoute;
}

const LocaleAuthenticatedShopifyRouteRouteChildren: LocaleAuthenticatedShopifyRouteRouteChildren =
  {
    LocaleAuthenticatedShopifyStockControlRoute:
      LocaleAuthenticatedShopifyStockControlRoute,
    LocaleAuthenticatedShopifyIndexRoute: LocaleAuthenticatedShopifyIndexRoute,
  };

const LocaleAuthenticatedShopifyRouteRouteWithChildren =
  LocaleAuthenticatedShopifyRouteRoute._addFileChildren(
    LocaleAuthenticatedShopifyRouteRouteChildren,
  );

interface LocaleAuthenticatedStudentRouteRouteChildren {
  LocaleAuthenticatedStudentMy_coursesRoute: typeof LocaleAuthenticatedStudentMy_coursesRoute;
  LocaleAuthenticatedStudentPersonalFlowRoute: typeof LocaleAuthenticatedStudentPersonalFlowRoute;
  LocaleAuthenticatedStudentProgressRoute: typeof LocaleAuthenticatedStudentProgressRoute;
  LocaleAuthenticatedStudentIndexRoute: typeof LocaleAuthenticatedStudentIndexRoute;
  LocaleAuthenticatedStudentCoursesCourseIdRoute: typeof LocaleAuthenticatedStudentCoursesCourseIdRoute;
  LocaleAuthenticatedStudentDocumentsDocumentIdRoute: typeof LocaleAuthenticatedStudentDocumentsDocumentIdRoute;
  LocaleAuthenticatedStudentEducationModulesModuleIdRoute: typeof LocaleAuthenticatedStudentEducationModulesModuleIdRoute;
  LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute: typeof LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute;
  LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute: typeof LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute;
}

const LocaleAuthenticatedStudentRouteRouteChildren: LocaleAuthenticatedStudentRouteRouteChildren =
  {
    LocaleAuthenticatedStudentMy_coursesRoute:
      LocaleAuthenticatedStudentMy_coursesRoute,
    LocaleAuthenticatedStudentPersonalFlowRoute:
      LocaleAuthenticatedStudentPersonalFlowRoute,
    LocaleAuthenticatedStudentProgressRoute:
      LocaleAuthenticatedStudentProgressRoute,
    LocaleAuthenticatedStudentIndexRoute: LocaleAuthenticatedStudentIndexRoute,
    LocaleAuthenticatedStudentCoursesCourseIdRoute:
      LocaleAuthenticatedStudentCoursesCourseIdRoute,
    LocaleAuthenticatedStudentDocumentsDocumentIdRoute:
      LocaleAuthenticatedStudentDocumentsDocumentIdRoute,
    LocaleAuthenticatedStudentEducationModulesModuleIdRoute:
      LocaleAuthenticatedStudentEducationModulesModuleIdRoute,
    LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute:
      LocaleAuthenticatedStudentOnboardingActivitiesActivityKeyRoute,
    LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute:
      LocaleAuthenticatedStudentRegistrationsRegistrationIdActivitiesActivityKeyRoute,
  };

const LocaleAuthenticatedStudentRouteRouteWithChildren =
  LocaleAuthenticatedStudentRouteRoute._addFileChildren(
    LocaleAuthenticatedStudentRouteRouteChildren,
  );

interface LocaleAuthenticatedSyncRouteRouteChildren {
  LocaleAuthenticatedSyncDataTypesRoute: typeof LocaleAuthenticatedSyncDataTypesRoute;
  LocaleAuthenticatedSyncJobsRoute: typeof LocaleAuthenticatedSyncJobsRoute;
  LocaleAuthenticatedSyncOptionSetsRoute: typeof LocaleAuthenticatedSyncOptionSetsRoute;
  LocaleAuthenticatedSyncRelationQueueRoute: typeof LocaleAuthenticatedSyncRelationQueueRoute;
  LocaleAuthenticatedSyncSweepRunsRoute: typeof LocaleAuthenticatedSyncSweepRunsRoute;
  LocaleAuthenticatedSyncIndexRoute: typeof LocaleAuthenticatedSyncIndexRoute;
}

const LocaleAuthenticatedSyncRouteRouteChildren: LocaleAuthenticatedSyncRouteRouteChildren =
  {
    LocaleAuthenticatedSyncDataTypesRoute:
      LocaleAuthenticatedSyncDataTypesRoute,
    LocaleAuthenticatedSyncJobsRoute: LocaleAuthenticatedSyncJobsRoute,
    LocaleAuthenticatedSyncOptionSetsRoute:
      LocaleAuthenticatedSyncOptionSetsRoute,
    LocaleAuthenticatedSyncRelationQueueRoute:
      LocaleAuthenticatedSyncRelationQueueRoute,
    LocaleAuthenticatedSyncSweepRunsRoute:
      LocaleAuthenticatedSyncSweepRunsRoute,
    LocaleAuthenticatedSyncIndexRoute: LocaleAuthenticatedSyncIndexRoute,
  };

const LocaleAuthenticatedSyncRouteRouteWithChildren =
  LocaleAuthenticatedSyncRouteRoute._addFileChildren(
    LocaleAuthenticatedSyncRouteRouteChildren,
  );

interface LocaleAuthenticatedWarehouseRouteRouteChildren {
  LocaleAuthenticatedWarehouseInventoryRoute: typeof LocaleAuthenticatedWarehouseInventoryRoute;
  LocaleAuthenticatedWarehouseWarehousesRoute: typeof LocaleAuthenticatedWarehouseWarehousesRoute;
  LocaleAuthenticatedWarehouseReportsLazyRoute: typeof LocaleAuthenticatedWarehouseReportsLazyRoute;
  LocaleAuthenticatedWarehouseIndexRoute: typeof LocaleAuthenticatedWarehouseIndexRoute;
}

const LocaleAuthenticatedWarehouseRouteRouteChildren: LocaleAuthenticatedWarehouseRouteRouteChildren =
  {
    LocaleAuthenticatedWarehouseInventoryRoute:
      LocaleAuthenticatedWarehouseInventoryRoute,
    LocaleAuthenticatedWarehouseWarehousesRoute:
      LocaleAuthenticatedWarehouseWarehousesRoute,
    LocaleAuthenticatedWarehouseReportsLazyRoute:
      LocaleAuthenticatedWarehouseReportsLazyRoute,
    LocaleAuthenticatedWarehouseIndexRoute:
      LocaleAuthenticatedWarehouseIndexRoute,
  };

const LocaleAuthenticatedWarehouseRouteRouteWithChildren =
  LocaleAuthenticatedWarehouseRouteRoute._addFileChildren(
    LocaleAuthenticatedWarehouseRouteRouteChildren,
  );

interface LocaleAuthenticatedPaymentsRouteChildren {
  LocaleAuthenticatedPaymentsPaymentIdRoute: typeof LocaleAuthenticatedPaymentsPaymentIdRoute;
}

const LocaleAuthenticatedPaymentsRouteChildren: LocaleAuthenticatedPaymentsRouteChildren =
  {
    LocaleAuthenticatedPaymentsPaymentIdRoute:
      LocaleAuthenticatedPaymentsPaymentIdRoute,
  };

const LocaleAuthenticatedPaymentsRouteWithChildren =
  LocaleAuthenticatedPaymentsRoute._addFileChildren(
    LocaleAuthenticatedPaymentsRouteChildren,
  );

interface LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteChildren {
  LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute: typeof LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute;
}

const LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteChildren: LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteChildren =
  {
    LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute:
      LocaleAuthenticatedCrmCustomersCustomerIdSplatRoute,
  };

const LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren =
  LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute._addFileChildren(
    LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteChildren,
  );

interface LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteChildren {
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute;
}

const LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteChildren: LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteChildren =
  {
    LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsDocumentIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsNewRoute,
  };

const LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute._addFileChildren(
    LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteChildren,
  );

interface LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteChildren {
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute;
}

const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteChildren: LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteChildren =
  {
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningIndexRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCertificationsCertificationIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningCoursesCourseIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningEducationModuleLogsEducationModuleLogIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRegistrationsRegistrationIdCompletionFormDocumentIdRoute,
  };

const LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteWithChildren =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute._addFileChildren(
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteChildren,
  );

interface LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteChildren {
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute;
}

const LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteChildren: LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteChildren =
  {
    LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingProgramLogIdRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingIndexRoute,
  };

const LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteWithChildren =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute._addFileChildren(
    LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteChildren,
  );

interface LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteChildren {
  LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteWithChildren;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteWithChildren;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute;
}

const LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteChildren: LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteChildren =
  {
    LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdAreaKeyRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdDocumentsRouteWithChildren,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdHelpdeskRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdLearningRouteWithChildren,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdMembershipRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdPaymentsRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdSyncRoute,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdTrainingRouteWithChildren,
    LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute:
      LocaleAuthenticatedCrmUserProfilesUserProfileIdIndexRoute,
  };

const LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteWithChildren =
  LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute._addFileChildren(
    LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteChildren,
  );

interface LocaleAuthenticatedCrmHelpdeskArticlesRouteChildren {
  LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute;
  LocaleAuthenticatedCrmHelpdeskArticlesNewRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesNewRoute;
  LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute;
}

const LocaleAuthenticatedCrmHelpdeskArticlesRouteChildren: LocaleAuthenticatedCrmHelpdeskArticlesRouteChildren =
  {
    LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute:
      LocaleAuthenticatedCrmHelpdeskArticlesArticleIdRoute,
    LocaleAuthenticatedCrmHelpdeskArticlesNewRoute:
      LocaleAuthenticatedCrmHelpdeskArticlesNewRoute,
    LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute:
      LocaleAuthenticatedCrmHelpdeskArticlesIndexRoute,
  };

const LocaleAuthenticatedCrmHelpdeskArticlesRouteWithChildren =
  LocaleAuthenticatedCrmHelpdeskArticlesRoute._addFileChildren(
    LocaleAuthenticatedCrmHelpdeskArticlesRouteChildren,
  );

interface LocaleAuthenticatedCrmHelpdeskInstructionsRouteChildren {
  LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute;
  LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute;
  LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute;
}

const LocaleAuthenticatedCrmHelpdeskInstructionsRouteChildren: LocaleAuthenticatedCrmHelpdeskInstructionsRouteChildren =
  {
    LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute:
      LocaleAuthenticatedCrmHelpdeskInstructionsInstructionIdRoute,
    LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute:
      LocaleAuthenticatedCrmHelpdeskInstructionsNewRoute,
    LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute:
      LocaleAuthenticatedCrmHelpdeskInstructionsIndexRoute,
  };

const LocaleAuthenticatedCrmHelpdeskInstructionsRouteWithChildren =
  LocaleAuthenticatedCrmHelpdeskInstructionsRoute._addFileChildren(
    LocaleAuthenticatedCrmHelpdeskInstructionsRouteChildren,
  );

interface LocaleAuthenticatedCrmHelpdeskPromptsRouteChildren {
  LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute;
  LocaleAuthenticatedCrmHelpdeskPromptsNewRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsNewRoute;
  LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute;
}

const LocaleAuthenticatedCrmHelpdeskPromptsRouteChildren: LocaleAuthenticatedCrmHelpdeskPromptsRouteChildren =
  {
    LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute:
      LocaleAuthenticatedCrmHelpdeskPromptsPromptIdRoute,
    LocaleAuthenticatedCrmHelpdeskPromptsNewRoute:
      LocaleAuthenticatedCrmHelpdeskPromptsNewRoute,
    LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute:
      LocaleAuthenticatedCrmHelpdeskPromptsIndexRoute,
  };

const LocaleAuthenticatedCrmHelpdeskPromptsRouteWithChildren =
  LocaleAuthenticatedCrmHelpdeskPromptsRoute._addFileChildren(
    LocaleAuthenticatedCrmHelpdeskPromptsRouteChildren,
  );

interface LocaleAuthenticatedRouteChildren {
  LocaleAuthenticatedAdminRouteRoute: typeof LocaleAuthenticatedAdminRouteRouteWithChildren;
  LocaleAuthenticatedAnalyticsRouteRoute: typeof LocaleAuthenticatedAnalyticsRouteRouteWithChildren;
  LocaleAuthenticatedAnalyticsMoveRouteRoute: typeof LocaleAuthenticatedAnalyticsMoveRouteRouteWithChildren;
  LocaleAuthenticatedErpSyncRouteRoute: typeof LocaleAuthenticatedErpSyncRouteRouteWithChildren;
  LocaleAuthenticatedGearErpRouteRoute: typeof LocaleAuthenticatedGearErpRouteRouteWithChildren;
  LocaleAuthenticatedInstructorRouteRoute: typeof LocaleAuthenticatedInstructorRouteRouteWithChildren;
  LocaleAuthenticatedShopifyRouteRoute: typeof LocaleAuthenticatedShopifyRouteRouteWithChildren;
  LocaleAuthenticatedStudentRouteRoute: typeof LocaleAuthenticatedStudentRouteRouteWithChildren;
  LocaleAuthenticatedSyncRouteRoute: typeof LocaleAuthenticatedSyncRouteRouteWithChildren;
  LocaleAuthenticatedWarehouseRouteRoute: typeof LocaleAuthenticatedWarehouseRouteRouteWithChildren;
  LocaleAuthenticatedAccountRoute: typeof LocaleAuthenticatedAccountRoute;
  LocaleAuthenticatedAnalyticsGearRoute: typeof LocaleAuthenticatedAnalyticsGearRoute;
  LocaleAuthenticatedDashboardRoute: typeof LocaleAuthenticatedDashboardRoute;
  LocaleAuthenticatedPaymentsRoute: typeof LocaleAuthenticatedPaymentsRouteWithChildren;
  LocaleAuthenticatedTeamDashboardRoute: typeof LocaleAuthenticatedTeamDashboardRoute;
  LocaleAuthenticatedTranslationsRoute: typeof LocaleAuthenticatedTranslationsRoute;
  LocaleAuthenticatedCrmAnalyticsRoute: typeof LocaleAuthenticatedCrmAnalyticsRoute;
  LocaleAuthenticatedCrmSearchRoute: typeof LocaleAuthenticatedCrmSearchRoute;
  LocaleAuthenticatedCrmIndexRoute: typeof LocaleAuthenticatedCrmIndexRoute;
  LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute: typeof LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren;
  LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute: typeof LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteWithChildren;
  LocaleAuthenticatedCrmCoursesCourseIdRoute: typeof LocaleAuthenticatedCrmCoursesCourseIdRoute;
  LocaleAuthenticatedCrmHelpdeskTaskUuidRoute: typeof LocaleAuthenticatedCrmHelpdeskTaskUuidRoute;
  LocaleAuthenticatedCrmHelpdeskArticlesRoute: typeof LocaleAuthenticatedCrmHelpdeskArticlesRouteWithChildren;
  LocaleAuthenticatedCrmHelpdeskInstructionsRoute: typeof LocaleAuthenticatedCrmHelpdeskInstructionsRouteWithChildren;
  LocaleAuthenticatedCrmHelpdeskPromptsRoute: typeof LocaleAuthenticatedCrmHelpdeskPromptsRouteWithChildren;
  LocaleAuthenticatedCrmHelpdeskSettingsRoute: typeof LocaleAuthenticatedCrmHelpdeskSettingsRoute;
  LocaleAuthenticatedCrmMembershipsMembershipIdRoute: typeof LocaleAuthenticatedCrmMembershipsMembershipIdRoute;
  LocaleAuthenticatedCrmHelpdeskIndexRoute: typeof LocaleAuthenticatedCrmHelpdeskIndexRoute;
  LocaleAuthenticatedCrmMembershipsIndexRoute: typeof LocaleAuthenticatedCrmMembershipsIndexRoute;
}

const LocaleAuthenticatedRouteChildren: LocaleAuthenticatedRouteChildren = {
  LocaleAuthenticatedAdminRouteRoute:
    LocaleAuthenticatedAdminRouteRouteWithChildren,
  LocaleAuthenticatedAnalyticsRouteRoute:
    LocaleAuthenticatedAnalyticsRouteRouteWithChildren,
  LocaleAuthenticatedAnalyticsMoveRouteRoute:
    LocaleAuthenticatedAnalyticsMoveRouteRouteWithChildren,
  LocaleAuthenticatedErpSyncRouteRoute:
    LocaleAuthenticatedErpSyncRouteRouteWithChildren,
  LocaleAuthenticatedGearErpRouteRoute:
    LocaleAuthenticatedGearErpRouteRouteWithChildren,
  LocaleAuthenticatedInstructorRouteRoute:
    LocaleAuthenticatedInstructorRouteRouteWithChildren,
  LocaleAuthenticatedShopifyRouteRoute:
    LocaleAuthenticatedShopifyRouteRouteWithChildren,
  LocaleAuthenticatedStudentRouteRoute:
    LocaleAuthenticatedStudentRouteRouteWithChildren,
  LocaleAuthenticatedSyncRouteRoute:
    LocaleAuthenticatedSyncRouteRouteWithChildren,
  LocaleAuthenticatedWarehouseRouteRoute:
    LocaleAuthenticatedWarehouseRouteRouteWithChildren,
  LocaleAuthenticatedAccountRoute: LocaleAuthenticatedAccountRoute,
  LocaleAuthenticatedAnalyticsGearRoute: LocaleAuthenticatedAnalyticsGearRoute,
  LocaleAuthenticatedDashboardRoute: LocaleAuthenticatedDashboardRoute,
  LocaleAuthenticatedPaymentsRoute:
    LocaleAuthenticatedPaymentsRouteWithChildren,
  LocaleAuthenticatedTeamDashboardRoute: LocaleAuthenticatedTeamDashboardRoute,
  LocaleAuthenticatedTranslationsRoute: LocaleAuthenticatedTranslationsRoute,
  LocaleAuthenticatedCrmAnalyticsRoute: LocaleAuthenticatedCrmAnalyticsRoute,
  LocaleAuthenticatedCrmSearchRoute: LocaleAuthenticatedCrmSearchRoute,
  LocaleAuthenticatedCrmIndexRoute: LocaleAuthenticatedCrmIndexRoute,
  LocaleAuthenticatedCrmCustomersCustomerIdRouteRoute:
    LocaleAuthenticatedCrmCustomersCustomerIdRouteRouteWithChildren,
  LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRoute:
    LocaleAuthenticatedCrmUserProfilesUserProfileIdRouteRouteWithChildren,
  LocaleAuthenticatedCrmCoursesCourseIdRoute:
    LocaleAuthenticatedCrmCoursesCourseIdRoute,
  LocaleAuthenticatedCrmHelpdeskTaskUuidRoute:
    LocaleAuthenticatedCrmHelpdeskTaskUuidRoute,
  LocaleAuthenticatedCrmHelpdeskArticlesRoute:
    LocaleAuthenticatedCrmHelpdeskArticlesRouteWithChildren,
  LocaleAuthenticatedCrmHelpdeskInstructionsRoute:
    LocaleAuthenticatedCrmHelpdeskInstructionsRouteWithChildren,
  LocaleAuthenticatedCrmHelpdeskPromptsRoute:
    LocaleAuthenticatedCrmHelpdeskPromptsRouteWithChildren,
  LocaleAuthenticatedCrmHelpdeskSettingsRoute:
    LocaleAuthenticatedCrmHelpdeskSettingsRoute,
  LocaleAuthenticatedCrmMembershipsMembershipIdRoute:
    LocaleAuthenticatedCrmMembershipsMembershipIdRoute,
  LocaleAuthenticatedCrmHelpdeskIndexRoute:
    LocaleAuthenticatedCrmHelpdeskIndexRoute,
  LocaleAuthenticatedCrmMembershipsIndexRoute:
    LocaleAuthenticatedCrmMembershipsIndexRoute,
};

const LocaleAuthenticatedRouteWithChildren =
  LocaleAuthenticatedRoute._addFileChildren(LocaleAuthenticatedRouteChildren);

interface LocaleRouteChildren {
  LocaleAuthenticatedRoute: typeof LocaleAuthenticatedRouteWithChildren;
  LocaleCliAuthRoute: typeof LocaleCliAuthRoute;
  LocaleForgotPasswordRoute: typeof LocaleForgotPasswordRoute;
  LocaleInstructorGrowthOperatingSystemRoute: typeof LocaleInstructorGrowthOperatingSystemRoute;
  LocaleLoginRoute: typeof LocaleLoginRoute;
  LocaleRegisterRoute: typeof LocaleRegisterRoute;
  LocaleRequestLoginLinkRoute: typeof LocaleRequestLoginLinkRoute;
  LocaleSignupRoute: typeof LocaleSignupRoute;
  LocaleStudentRoute: typeof LocaleStudentRoute;
  LocaleUnauthorizedRoute: typeof LocaleUnauthorizedRoute;
  LocaleIndexRoute: typeof LocaleIndexRoute;
  LocaleCoursesCourseIdRoute: typeof LocaleCoursesCourseIdRoute;
  LocaleCoursesIndexRoute: typeof LocaleCoursesIndexRoute;
  LocaleUiLibraryIndexRoute: typeof LocaleUiLibraryIndexRoute;
  LocaleRecoveryLoginLinkRecoveryRequestIdRoute: typeof LocaleRecoveryLoginLinkRecoveryRequestIdRoute;
  LocaleRecoveryPasswordResetRecoveryRequestIdRoute: typeof LocaleRecoveryPasswordResetRecoveryRequestIdRoute;
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleAuthenticatedRoute: LocaleAuthenticatedRouteWithChildren,
  LocaleCliAuthRoute: LocaleCliAuthRoute,
  LocaleForgotPasswordRoute: LocaleForgotPasswordRoute,
  LocaleInstructorGrowthOperatingSystemRoute:
    LocaleInstructorGrowthOperatingSystemRoute,
  LocaleLoginRoute: LocaleLoginRoute,
  LocaleRegisterRoute: LocaleRegisterRoute,
  LocaleRequestLoginLinkRoute: LocaleRequestLoginLinkRoute,
  LocaleSignupRoute: LocaleSignupRoute,
  LocaleStudentRoute: LocaleStudentRoute,
  LocaleUnauthorizedRoute: LocaleUnauthorizedRoute,
  LocaleIndexRoute: LocaleIndexRoute,
  LocaleCoursesCourseIdRoute: LocaleCoursesCourseIdRoute,
  LocaleCoursesIndexRoute: LocaleCoursesIndexRoute,
  LocaleUiLibraryIndexRoute: LocaleUiLibraryIndexRoute,
  LocaleRecoveryLoginLinkRecoveryRequestIdRoute:
    LocaleRecoveryLoginLinkRecoveryRequestIdRoute,
  LocaleRecoveryPasswordResetRecoveryRequestIdRoute:
    LocaleRecoveryPasswordResetRecoveryRequestIdRoute,
};

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRoute: LocaleRouteWithChildren,
  DashboardRoute: DashboardRoute,
  HealthzRoute: HealthzRoute,
  LocaleHelpdeskRoute: LocaleHelpdeskRoute,
  CertificatesCertificateLogIdRoute: CertificatesCertificateLogIdRoute,
  LocaleHelpdeskConnectRoute: LocaleHelpdeskConnectRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
